// import React, { useState, useEffect } from 'react';
// import { useNavigate } from 'react-router-dom'; // Import useNavigate for navigation

// const SupplyChainAndProcurement = () => {
//   const [activeTab, setActiveTab] = useState('directory');
//   const [vendors, setVendors] = useState([]);
//   const [selectedVendor, setSelectedVendor] = useState(null);
//   const [searchTerm, setSearchTerm] = useState('');
//   const [showCreatePOModal, setShowCreatePOModal] = useState(false);
//   const [showRequestPOModal, setShowRequestPOModal] = useState(false);
//   const [vendorOrders, setVendorOrders] = useState([]);
//   const [vendorPayments, setVendorPayments] = useState([]);
//   const [pendingApprovals, setPendingApprovals] = useState([]);
//   const navigate = useNavigate();

//   // Form states
//   const [poForm, setPoForm] = useState({
//     vendor: '',
//     department: '',
//     items: [{ name: '', quantity: 1, unitPrice: 0 }],
//     dateRequired: '',
//     priority: 'medium'
//   });

//   const [requestForm, setRequestForm] = useState({
//     vendor: '',
//     department: '',
//     items: [{ name: '', quantity: 1, unitPrice: 0 }],
//     dateRequired: '',
//     reason: '',
//     priority: 'medium'
//   });

//   // Sample data - This would come from your master data management
//   useEffect(() => {
//     // Vendors data from master data
//     setVendors([
//       {
//         id: 1,
//         name: 'ABC Cleaning Supplies',
//         contactPerson: 'John Doe',
//         email: 'john@abccleaning.com',
//         phone: '+1-234-567-8900',
//         address: '123 Industrial Ave, New York, NY 10001',
//         category: 'Cleaning Supplies',
//         paymentTerms: 'Net 30',
//         taxId: '12-3456789',
//         bankAccount: '****1234',
//         rating: 4.5,
//         totalOrders: 47,
//         totalSpend: 125000,
//         onTimeDelivery: 92,
//         qualityRating: 4.3,
//         status: 'active',
//         dateAdded: '2023-01-15'
//       },
//       {
//         id: 2,
//         name: 'Hotel Linens Inc',
//         contactPerson: 'Sarah Smith',
//         email: 'sarah@hotellinens.com',
//         phone: '+1-234-567-8901',
//         address: '456 Textile Road, Chicago, IL 60007',
//         category: 'Linens & Textiles',
//         paymentTerms: 'Net 45',
//         taxId: '98-7654321',
//         bankAccount: '****5678',
//         rating: 4.8,
//         totalOrders: 32,
//         totalSpend: 89000,
//         onTimeDelivery: 96,
//         qualityRating: 4.7,
//         status: 'active',
//         dateAdded: '2023-02-20'
//       },
//       {
//         id: 3,
//         name: 'Kitchen Equipment Co',
//         contactPerson: 'Mike Johnson',
//         email: 'mike@kitchenequip.com',
//         phone: '+1-234-567-8902',
//         address: '789 Culinary Street, San Francisco, CA 94102',
//         category: 'Kitchen Equipment',
//         paymentTerms: 'Net 30',
//         taxId: '45-6789012',
//         bankAccount: '****9012',
//         rating: 4.2,
//         totalOrders: 28,
//         totalSpend: 215000,
//         onTimeDelivery: 88,
//         qualityRating: 4.1,
//         status: 'active',
//         dateAdded: '2023-03-10'
//       }
//     ]);

//     // Existing orders
//     setVendorOrders([
//       {
//         id: 'PO-2024-001',
//         vendorId: 1,
//         vendorName: 'ABC Cleaning Supplies',
//         items: [
//           { name: 'Brooms', quantity: 5, unitPrice: 15.99 },
//           { name: 'Cleaning Cloths', quantity: 20, unitPrice: 2.50 }
//         ],
//         total: 259.85,
//         status: 'delivered',
//         orderDate: '2024-01-15',
//         deliveryDate: '2024-01-18',
//         expectedDate: '2024-01-20',
//         approvedBy: 'David Chen',
//         type: 'direct'
//       },
//       {
//         id: 'PO-2024-002',
//         vendorId: 2,
//         vendorName: 'Hotel Linens Inc',
//         items: [
//           { name: 'Queen Bed Sheets', quantity: 50, unitPrice: 25.00 }
//         ],
//         total: 1250.00,
//         status: 'ordered',
//         orderDate: '2024-01-16',
//         deliveryDate: '',
//         expectedDate: '2024-01-25',
//         approvedBy: 'David Chen',
//         type: 'direct'
//       }
//     ]);

//     // Pending approvals for manager
//     setPendingApprovals([
//       {
//         id: 'PR-2024-003',
//         vendorId: 3,
//         vendorName: 'Kitchen Equipment Co',
//         requestedBy: 'Maria Garcia',
//         department: 'Kitchen',
//         items: [
//           { name: 'Chef Knives', quantity: 10, unitPrice: 45.00 }
//         ],
//         total: 450.00,
//         status: 'pending',
//         dateRequested: '2024-01-18',
//         dateRequired: '2024-01-30',
//         reason: 'Regular equipment replacement',
//         priority: 'high'
//       }
//     ]);

//     // Vendor payments
//     setVendorPayments([
//       {
//         id: 1,
//         vendorId: 1,
//         vendorName: 'ABC Cleaning Supplies',
//         invoiceNumber: 'INV-001',
//         amount: 1250.00,
//         dueDate: '2024-02-15',
//         status: 'pending',
//         orderId: 'PO-2024-001'
//       },
//       {
//         id: 2,
//         vendorId: 2,
//         vendorName: 'Hotel Linens Inc',
//         invoiceNumber: 'INV-002',
//         amount: 2050.00,
//         dueDate: '2024-02-28',
//         status: 'pending',
//         orderId: 'PO-2024-002'
//       }
//     ]);
//   }, []);

//   // Filter vendors
//   const filteredVendors = vendors.filter(vendor =>
//     vendor.name.toLowerCase().includes(searchTerm.toLowerCase()) ||
//     vendor.contactPerson.toLowerCase().includes(searchTerm.toLowerCase()) ||
//     vendor.category.toLowerCase().includes(searchTerm.toLowerCase())
//   );

//   // Get vendor orders
//   const getVendorOrders = (vendorId) => {
//     return vendorOrders.filter(order => order.vendorId === vendorId);
//   };

//   // Get vendor payments
//   const getVendorPayments = (vendorId) => {
//     return vendorPayments.filter(payment => payment.vendorId === vendorId);
//   };

//   // Status badge component
//   const StatusBadge = ({ status, type = 'order' }) => {
//     const statusConfig = {
//       order: {
//         pending: { color: 'bg-yellow-100 text-yellow-800', text: 'Pending' },
//         ordered: { color: 'bg-blue-100 text-blue-800', text: 'Ordered' },
//         delivered: { color: 'bg-green-100 text-green-800', text: 'Delivered' },
//         cancelled: { color: 'bg-red-100 text-red-800', text: 'Cancelled' }
//       },
//       payment: {
//         pending: { color: 'bg-yellow-100 text-yellow-800', text: 'Pending' },
//         paid: { color: 'bg-green-100 text-green-800', text: 'Paid' },
//         overdue: { color: 'bg-red-100 text-red-800', text: 'Overdue' }
//       },
//       approval: {
//         pending: { color: 'bg-yellow-100 text-yellow-800', text: 'Pending Review' },
//         approved: { color: 'bg-green-100 text-green-800', text: 'Approved' },
//         rejected: { color: 'bg-red-100 text-red-800', text: 'Rejected' }
//       }
//     };

//     const config = statusConfig[type][status] || statusConfig.order.pending;
//     return (
//       <span className={`px-2 py-1 rounded-full text-xs font-medium ${config.color}`}>
//         {config.text}
//       </span>
//     );
//   };

//   // Rating stars component
//   const RatingStars = ({ rating }) => {
//     return (
//       <div className="flex items-center">
//         {[1, 2, 3, 4, 5].map((star) => (
//           <svg
//             key={star}
//             className={`w-4 h-4 ${star <= rating ? 'text-yellow-400' : 'text-gray-300'}`}
//             fill="currentColor"
//             viewBox="0 0 20 20"
//           >
//             <path d="M9.049 2.927c.3-.921 1.603-.921 1.902 0l1.07 3.292a1 1 0 00.95.69h3.462c.969 0 1.371 1.24.588 1.81l-2.8 2.034a1 1 0 00-.364 1.118l1.07 3.292c.3.921-.755 1.688-1.54 1.118l-2.8-2.034a1 1 0 00-1.175 0l-2.8 2.034c-.784.57-1.838-.197-1.539-1.118l1.07-3.292a1 1 0 00-.364-1.118L2.98 8.72c-.783-.57-.38-1.81.588-1.81h3.461a1 1 0 00.951-.69l1.07-3.292z" />
//           </svg>
//         ))}
//       </div>
//     );
//   };

//   // Item management functions
//   const addItem = (isRequest = false) => {
//     if (isRequest) {
//       setRequestForm({
//         ...requestForm,
//         items: [...requestForm.items, { name: '', quantity: 1, unitPrice: 0 }]
//       });
//     } else {
//       setPoForm({
//         ...poForm,
//         items: [...poForm.items, { name: '', quantity: 1, unitPrice: 0 }]
//       });
//     }
//   };

//   const updateItem = (index, field, value, isRequest = false) => {
//     if (isRequest) {
//       const updatedItems = requestForm.items.map((item, i) =>
//         i === index ? { ...item, [field]: value } : item
//       );
//       setRequestForm({ ...requestForm, items: updatedItems });
//     } else {
//       const updatedItems = poForm.items.map((item, i) =>
//         i === index ? { ...item, [field]: value } : item
//       );
//       setPoForm({ ...poForm, items: updatedItems });
//     }
//   };

//   const removeItem = (index, isRequest = false) => {
//     if (isRequest) {
//       const updatedItems = requestForm.items.filter((_, i) => i !== index);
//       setRequestForm({ ...requestForm, items: updatedItems });
//     } else {
//       const updatedItems = poForm.items.filter((_, i) => i !== index);
//       setPoForm({ ...poForm, items: updatedItems });
//     }
//   };

//   const calculateTotal = (items) => {
//     return items.reduce((total, item) => total + (item.quantity * item.unitPrice), 0);
//   };

//   // Action functions
//   const createPurchaseOrder = (e) => {
//     e.preventDefault();
//     const newOrder = {
//       id: `PO-2024-00${vendorOrders.length + 1}`,
//       vendorId: vendors.find(v => v.name === poForm.vendor)?.id,
//       vendorName: poForm.vendor,
//       items: poForm.items,
//       total: calculateTotal(poForm.items),
//       status: 'ordered',
//       orderDate: new Date().toISOString().split('T')[0],
//       expectedDate: poForm.dateRequired,
//       approvedBy: 'Admin User',
//       type: 'direct'
//     };

//     setVendorOrders([newOrder, ...vendorOrders]);

//     // Send to vendor (simulated)
//     const vendor = vendors.find(v => v.name === poForm.vendor);
//     alert(`PO created and sent to ${vendor.name} at ${vendor.email}`);

//     setShowCreatePOModal(false);
//     resetPoForm();
//   };

//   const submitPurchaseRequest = (e) => {
//     e.preventDefault();
//     const newRequest = {
//       id: `PR-2024-00${pendingApprovals.length + 1}`,
//       vendorId: vendors.find(v => v.name === requestForm.vendor)?.id,
//       vendorName: requestForm.vendor,
//       requestedBy: 'Staff User',
//       department: requestForm.department,
//       items: requestForm.items,
//       total: calculateTotal(requestForm.items),
//       status: 'pending',
//       dateRequested: new Date().toISOString().split('T')[0],
//       dateRequired: requestForm.dateRequired,
//       reason: requestForm.reason,
//       priority: requestForm.priority
//     };

//     setPendingApprovals([newRequest, ...pendingApprovals]);
//     alert('Purchase request submitted for manager approval');

//     setShowRequestPOModal(false);
//     resetRequestForm();
//   };

//   const approveRequest = (requestId) => {
//     const request = pendingApprovals.find(req => req.id === requestId);
//     if (request) {
//       const newOrder = {
//         ...request,
//         id: request.id.replace('PR', 'PO'),
//         status: 'ordered',
//         approvedBy: 'Manager User',
//         type: 'approved',
//         orderDate: new Date().toISOString().split('T')[0]
//       };

//       setVendorOrders([newOrder, ...vendorOrders]);
//       setPendingApprovals(pendingApprovals.filter(req => req.id !== requestId));

//       // Send to vendor (simulated)
//       const vendor = vendors.find(v => v.id === request.vendorId);
//       alert(`PO approved and sent to ${vendor.name} at ${vendor.email}`);
//     }
//   };

//   const rejectRequest = (requestId) => {
//     setPendingApprovals(pendingApprovals.filter(req => req.id !== requestId));
//     alert('Purchase request rejected');
//   };

//   const markPaymentPaid = (paymentId) => {
//     setVendorPayments(vendorPayments.map(payment =>
//       payment.id === paymentId ? { ...payment, status: 'paid', paymentDate: new Date().toISOString().split('T')[0] } : payment
//     ));
//     alert('Payment marked as paid');
//   };

//   const resetPoForm = () => {
//     setPoForm({
//       vendor: '',
//       department: '',
//       items: [{ name: '', quantity: 1, unitPrice: 0 }],
//       dateRequired: '',
//       priority: 'medium'
//     });
//   };

//   const resetRequestForm = () => {
//     setRequestForm({
//       vendor: '',
//       department: '',
//       items: [{ name: '', quantity: 1, unitPrice: 0 }],
//       dateRequired: '',
//       reason: '',
//       priority: 'medium'
//     });
//   };

//   return (
//     <div className="p-6 min-h-screen bg-gray-50">
//       <header className="flex justify-between items-center mb-3 bg-white p-3">
//         <h1 className="text-black text-xl font-bold ml-2">Supply Chain and Procurement</h1>
//         <div className="flex space-x-6">
//           <button
//             onClick={() => navigate("/dashboard/core-modules/supply-chain/vendor-management")}
//             className="btn text-black font-bold"
//           >
//             Vendor Management
//           </button>
//           <button
//             onClick={() => navigate("/dashboard/core-modules/supply-chain/inventory-procurement")}
//             className="btn"
//           >
//             Inventory and Procurement
//           </button>
//           <button
//             onClick={() => navigate("/dashboard/core-modules/supply-chain/cost-control-budgeting")}
//             className="btn"
//           >
//             Cost Control and Budgeting
//           </button>
//         </div>
//       </header>
//       <div className='px-4'>
//       {/* Header */}
//       <div className="flex justify-between items-center mb-6">
//         <div>
//           <h1 className="text-2xl font-bold text-gray-900">Vendor Management</h1>
//           <p className="text-gray-600">Manage vendor relationships, orders, and payments</p>
//         </div>
//         <div className="flex space-x-3">
//           <button
//             onClick={() => setShowRequestPOModal(true)}
//             className="bg-white text-gray-700 px-4 py-2 rounded-lg border border-gray-300 hover:bg-gray-50 flex items-center"
//           >
//             <svg className="w-5 h-5 mr-2" fill="none" stroke="currentColor" viewBox="0 0 24 24">
//               <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M12 9v3m0 0v3m0-3h3m-3 0H9m12 0a9 9 0 11-18 0 9 9 0 0118 0z" />
//             </svg>
//             Request PO
//           </button>
//           <button
//             onClick={() => setShowCreatePOModal(true)}
//             className="bg-black text-white px-4 py-2 rounded-lg hover:bg-gray-800 flex items-center"
//           >
//             <svg className="w-5 h-5 mr-2" fill="none" stroke="currentColor" viewBox="0 0 24 24">
//               <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M12 4v16m8-8H4" />
//             </svg>
//             Create PO
//           </button>
//         </div>
//       </div>

//       {/* Stats Cards */}
//       <div className="grid grid-cols-1 md:grid-cols-4 gap-6 mb-6">
//         <div className="bg-white p-6 rounded-lg border border-gray-200">
//           <div className="flex items-center">
//             <div className="p-3 bg-gray-100 rounded-lg">
//               <svg className="w-6 h-6 text-gray-600" fill="none" stroke="currentColor" viewBox="0 0 24 24">
//                 <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M17 20h5v-2a3 3 0 00-5.356-1.857M17 20H7m10 0v-2c0-.656-.126-1.283-.356-1.857M7 20H2v-2a3 3 0 015.356-1.857M7 20v-2c0-.656.126-1.283.356-1.857m0 0a5.002 5.002 0 019.288 0M15 7a3 3 0 11-6 0 3 3 0 016 0zm6 3a2 2 0 11-4 0 2 2 0 014 0zM7 10a2 2 0 11-4 0 2 2 0 014 0z" />
//               </svg>
//             </div>
//             <div className="ml-4">
//               <h3 className="text-2xl font-bold text-gray-900">{vendors.length}</h3>
//               <p className="text-gray-600">Total Vendors</p>
//             </div>
//           </div>
//         </div>

//         <div className="bg-white p-6 rounded-lg border border-gray-200">
//           <div className="flex items-center">
//             <div className="p-3 bg-gray-100 rounded-lg">
//               <svg className="w-6 h-6 text-gray-600" fill="none" stroke="currentColor" viewBox="0 0 24 24">
//                 <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 5H7a2 2 0 00-2 2v12a2 2 0 002 2h10a2 2 0 002-2V7a2 2 0 00-2-2h-2M9 5a2 2 0 002 2h2a2 2 0 002-2M9 5a2 2 0 012-2h2a2 2 0 012 2" />
//               </svg>
//             </div>
//             <div className="ml-4">
//               <h3 className="text-2xl font-bold text-gray-900">{vendorOrders.length}</h3>
//               <p className="text-gray-600">Total Orders</p>
//             </div>
//           </div>
//         </div>

//         <div className="bg-white p-6 rounded-lg border border-gray-200">
//           <div className="flex items-center">
//             <div className="p-3 bg-gray-100 rounded-lg">
//               <svg className="w-6 h-6 text-gray-600" fill="none" stroke="currentColor" viewBox="0 0 24 24">
//                 <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M12 8c-1.657 0-3 .895-3 2s1.343 2 3 2 3 .895 3 2-1.343 2-3 2m0-8c1.11 0 2.08.402 2.599 1M12 8V7m0 1v8m0 0v1m0-1c-1.11 0-2.08-.402-2.599-1" />
//               </svg>
//             </div>
//             <div className="ml-4">
//               <h3 className="text-2xl font-bold text-gray-900">
//                 ${vendorPayments.reduce((sum, payment) => sum + payment.amount, 0).toLocaleString()}
//               </h3>
//               <p className="text-gray-600">Pending Payments</p>
//             </div>
//           </div>
//         </div>

//         <div className="bg-white p-6 rounded-lg border border-gray-200">
//           <div className="flex items-center">
//             <div className="p-3 bg-gray-100 rounded-lg">
//               <svg className="w-6 h-6 text-gray-600" fill="none" stroke="currentColor" viewBox="0 0 24 24">
//                 <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 12l2 2 4-4m6 2a9 9 0 11-18 0 9 9 0 0118 0z" />
//               </svg>
//             </div>
//             <div className="ml-4">
//               <h3 className="text-2xl font-bold text-gray-900">{pendingApprovals.length}</h3>
//               <p className="text-gray-600">Pending Approvals</p>
//             </div>
//           </div>
//         </div>
//       </div>

//       {/* Main Tabs */}
//       <div className="bg-white rounded-lg border border-gray-200">
//         <div className="border-b border-gray-200">
//           <nav className="flex -mb-px">
//             {['directory', 'orders', 'payments', 'approvals'].map((tab) => (
//               <button
//                 key={tab}
//                 onClick={() => setActiveTab(tab)}
//                 className={`py-4 px-6 font-medium text-sm border-b-2 transition-colors ${activeTab === tab
//                     ? 'border-black text-black'
//                     : 'border-transparent text-gray-600 hover:text-black hover:border-gray-300'
//                   }`}
//               >
//                 {tab.charAt(0).toUpperCase() + tab.slice(1).replace(/([A-Z])/g, ' $1')}
//                 {tab === 'approvals' && pendingApprovals.length > 0 && (
//                   <span className="ml-2 bg-red-500 text-white rounded-full px-2 py-1 text-xs">
//                     {pendingApprovals.length}
//                   </span>
//                 )}
//               </button>
//             ))}
//           </nav>
//         </div>

//         <div className="p-6">
//           {/* Vendor Directory Tab */}
//           {activeTab === 'directory' && (
//             <div>
//               <div className="flex justify-between items-center mb-6">
//                 <div className="flex-1 max-w-md">
//                   <div className="relative">
//                     <input
//                       type="text"
//                       placeholder="Search vendors by name, contact, or category..."
//                       className="w-full pl-10 pr-4 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-black focus:border-transparent"
//                       value={searchTerm}
//                       onChange={(e) => setSearchTerm(e.target.value)}
//                     />
//                     <svg
//                       className="w-5 h-5 text-gray-400 absolute left-3 top-2.5"
//                       fill="none"
//                       stroke="currentColor"
//                       viewBox="0 0 24 24"
//                     >
//                       <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M21 21l-6-6m2-5a7 7 0 11-14 0 7 7 0 0114 0z" />
//                     </svg>
//                   </div>
//                 </div>
//               </div>

//               <div className="grid grid-cols-1 md:grid-cols-2 xl:grid-cols-3 gap-6">
//                 {filteredVendors.map((vendor) => (
//                   <div key={vendor.id} className="bg-white border border-gray-200 rounded-lg p-6 hover:shadow-md transition-shadow">
//                     <div className="flex justify-between items-start mb-4">
//                       <div className="flex-1">
//                         <h3 className="text-lg font-semibold text-gray-900 mb-1">{vendor.name}</h3>
//                         <p className="text-sm text-gray-600 mb-2">{vendor.category}</p>
//                         <div className="flex items-center space-x-2">
//                           <span className={`px-2 py-1 rounded-full text-xs font-medium ${vendor.status === 'active' ? 'bg-green-100 text-green-800' : 'bg-gray-100 text-gray-800'
//                             }`}>
//                             {vendor.status}
//                           </span>
//                           <RatingStars rating={vendor.rating} />
//                         </div>
//                       </div>
//                     </div>

//                     <div className="space-y-2 mb-4">
//                       <div className="flex items-center text-sm text-gray-600">
//                         <svg className="w-4 h-4 mr-2 flex-shrink-0" fill="none" stroke="currentColor" viewBox="0 0 24 24">
//                           <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M16 7a4 4 0 11-8 0 4 4 0 018 0zM12 14a7 7 0 00-7 7h14a7 7 0 00-7-7z" />
//                         </svg>
//                         {vendor.contactPerson}
//                       </div>
//                       <div className="flex items-center text-sm text-gray-600">
//                         <svg className="w-4 h-4 mr-2 flex-shrink-0" fill="none" stroke="currentColor" viewBox="0 0 24 24">
//                           <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M3 8l7.89 5.26a2 2 0 002.22 0L21 8M5 19h14a2 2 0 002-2V7a2 2 0 00-2-2H5a2 2 0 00-2 2v10a2 2 0 002 2z" />
//                         </svg>
//                         {vendor.email}
//                       </div>
//                       <div className="flex items-center text-sm text-gray-600">
//                         <svg className="w-4 h-4 mr-2 flex-shrink-0" fill="none" stroke="currentColor" viewBox="0 0 24 24">
//                           <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M3 5a2 2 0 012-2h3.28a1 1 0 01.948.684l1.498 4.493a1 1 0 01-.502 1.21l-2.257 1.13a11.042 11.042 0 005.516 5.516l1.13-2.257a1 1 0 011.21-.502l4.493 1.498a1 1 0 01.684.949V19a2 2 0 01-2 2h-1C9.716 21 3 14.284 3 6V5z" />
//                         </svg>
//                         {vendor.phone}
//                       </div>
//                     </div>

//                     <div className="grid grid-cols-2 gap-4 mb-4 text-center">
//                       <div>
//                         <div className="text-sm font-semibold text-gray-900">{vendor.totalOrders}</div>
//                         <div className="text-xs text-gray-600">Total Orders</div>
//                       </div>
//                       <div>
//                         <div className="text-sm font-semibold text-green-600">{vendor.onTimeDelivery}%</div>
//                         <div className="text-xs text-gray-600">On-Time Delivery</div>
//                       </div>
//                     </div>

//                     <div className="flex space-x-2">
//                       <button
//                         onClick={() => {
//                           setPoForm({ ...poForm, vendor: vendor.name });
//                           setShowCreatePOModal(true);
//                         }}
//                         className="flex-1 bg-black text-white px-3 py-2 rounded text-sm hover:bg-gray-800 transition-colors"
//                       >
//                         Create PO
//                       </button>
//                       <button
//                         onClick={() => {
//                           setSelectedVendor(vendor);
//                           setActiveTab('orders');
//                         }}
//                         className="flex-1 bg-white text-gray-700 px-3 py-2 rounded text-sm border border-gray-300 hover:bg-gray-50 transition-colors"
//                       >
//                         View Orders
//                       </button>
//                     </div>
//                   </div>
//                 ))}
//               </div>
//             </div>
//           )}

//           {/* Orders Tab */}
//           {activeTab === 'orders' && (
//             <div>
//               <div className="flex justify-between items-center mb-6">
//                 <h2 className="text-xl font-semibold text-gray-900">Purchase Orders</h2>
//                 <div className="flex space-x-3">
//                   <button
//                     onClick={() => setShowRequestPOModal(true)}
//                     className="bg-white text-gray-700 px-4 py-2 rounded-lg border border-gray-300 hover:bg-gray-50"
//                   >
//                     Request PO
//                   </button>
//                   <button
//                     onClick={() => setShowCreatePOModal(true)}
//                     className="bg-black text-white px-4 py-2 rounded-lg hover:bg-gray-800"
//                   >
//                     Create PO
//                   </button>
//                 </div>
//               </div>

//               <div className="overflow-x-auto">
//                 <table className="w-full">
//                   <thead>
//                     <tr className="bg-gray-50">
//                       <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">PO Number</th>
//                       <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">Vendor</th>
//                       <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">Order Date</th>
//                       <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">Total</th>
//                       <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">Status</th>
//                       <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">Type</th>
//                       <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">Actions</th>
//                     </tr>
//                   </thead>
//                   <tbody className="bg-white divide-y divide-gray-200">
//                     {vendorOrders.map((order) => (
//                       <tr key={order.id} className="hover:bg-gray-50">
//                         <td className="px-6 py-4 whitespace-nowrap">
//                           <div className="text-sm font-medium text-gray-900">{order.id}</div>
//                         </td>
//                         <td className="px-6 py-4 whitespace-nowrap">
//                           <div className="text-sm text-gray-900">{order.vendorName}</div>
//                         </td>
//                         <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-500">
//                           {order.orderDate}
//                         </td>
//                         <td className="px-6 py-4 whitespace-nowrap text-sm font-medium text-gray-900">
//                           ${order.total.toFixed(2)}
//                         </td>
//                         <td className="px-6 py-4 whitespace-nowrap">
//                           <StatusBadge status={order.status} type="order" />
//                         </td>
//                         <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-500">
//                           <span className={`px-2 py-1 rounded-full text-xs ${order.type === 'direct' ? 'bg-blue-100 text-blue-800' : 'bg-green-100 text-green-800'
//                             }`}>
//                             {order.type}
//                           </span>
//                         </td>
//                         <td className="px-6 py-4 whitespace-nowrap text-sm font-medium">
//                           <button className="text-blue-600 hover:text-blue-800 mr-3">View</button>
//                           <button className="text-green-600 hover:text-green-800">Track</button>
//                         </td>
//                       </tr>
//                     ))}
//                   </tbody>
//                 </table>
//               </div>
//             </div>
//           )}

//           {/* Payments Tab */}
//           {activeTab === 'payments' && (
//             <div>
//               <h2 className="text-xl font-semibold text-gray-900 mb-6">Vendor Payments</h2>
//               <div className="overflow-x-auto">
//                 <table className="w-full">
//                   <thead>
//                     <tr className="bg-gray-50">
//                       <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">Invoice</th>
//                       <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">Vendor</th>
//                       <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">Amount</th>
//                       <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">Due Date</th>
//                       <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">Status</th>
//                       <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">Actions</th>
//                     </tr>
//                   </thead>
//                   <tbody className="bg-white divide-y divide-gray-200">
//                     {vendorPayments.map((payment) => (
//                       <tr key={payment.id} className="hover:bg-gray-50">
//                         <td className="px-6 py-4 whitespace-nowrap">
//                           <div className="text-sm font-medium text-gray-900">{payment.invoiceNumber}</div>
//                           <div className="text-sm text-gray-500">{payment.orderId}</div>
//                         </td>
//                         <td className="px-6 py-4 whitespace-nowrap">
//                           <div className="text-sm text-gray-900">{payment.vendorName}</div>
//                         </td>
//                         <td className="px-6 py-4 whitespace-nowrap text-sm font-medium text-gray-900">
//                           ${payment.amount.toFixed(2)}
//                         </td>
//                         <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-500">
//                           {payment.dueDate}
//                         </td>
//                         <td className="px-6 py-4 whitespace-nowrap">
//                           <StatusBadge status={payment.status} type="payment" />
//                         </td>
//                         <td className="px-6 py-4 whitespace-nowrap text-sm font-medium">
//                           <button
//                             onClick={() => markPaymentPaid(payment.id)}
//                             className="bg-black text-white px-3 py-1 rounded text-sm hover:bg-gray-800 mr-2"
//                           >
//                             Mark Paid
//                           </button>
//                           <button className="text-blue-600 hover:text-blue-800">View</button>
//                         </td>
//                       </tr>
//                     ))}
//                   </tbody>
//                 </table>
//               </div>
//             </div>
//           )}

//           {/* Approvals Tab */}
//           {activeTab === 'approvals' && (
//             <div>
//               <h2 className="text-xl font-semibold text-gray-900 mb-6">Pending Approvals</h2>
//               {pendingApprovals.length === 0 ? (
//                 <div className="text-center py-8">
//                   <svg className="w-12 h-12 text-gray-400 mx-auto mb-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
//                     <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 12l2 2 4-4m6 2a9 9 0 11-18 0 9 9 0 0118 0z" />
//                   </svg>
//                   <p className="text-gray-500">No pending approvals</p>
//                 </div>
//               ) : (
//                 <div className="space-y-4">
//                   {pendingApprovals.map((request) => (
//                     <div key={request.id} className="bg-yellow-50 border border-yellow-200 rounded-lg p-6">
//                       <div className="flex justify-between items-start mb-4">
//                         <div className="flex-1">
//                           <div className="flex items-center space-x-3 mb-2">
//                             <h3 className="text-lg font-semibold text-gray-900">{request.id}</h3>
//                             <StatusBadge status={request.status} type="approval" />
//                             <span className={`px-2 py-1 rounded-full text-xs font-medium ${request.priority === 'high' ? 'bg-red-100 text-red-800' :
//                                 request.priority === 'medium' ? 'bg-yellow-100 text-yellow-800' :
//                                   'bg-green-100 text-green-800'
//                               }`}>
//                               {request.priority} priority
//                             </span>
//                           </div>
//                           <p className="text-sm text-gray-600">
//                             <strong>Vendor:</strong> {request.vendorName} |
//                             <strong> Requested by:</strong> {request.requestedBy} ({request.department}) |
//                             <strong> Required by:</strong> {request.dateRequired}
//                           </p>
//                           <p className="text-sm text-gray-600 mt-1">
//                             <strong>Reason:</strong> {request.reason}
//                           </p>

//                           <div className="mt-3">
//                             <strong className="text-sm">Items:</strong>
//                             <ul className="text-sm text-gray-600 ml-4 mt-1">
//                               {request.items.map((item, index) => (
//                                 <li key={index}>
//                                   {item.quantity}x {item.name} - ${item.unitPrice} each
//                                 </li>
//                               ))}
//                             </ul>
//                           </div>

//                           <p className="text-sm font-semibold mt-2">
//                             Total: ${request.total.toFixed(2)}
//                           </p>
//                         </div>
//                       </div>

//                       <div className="flex justify-end space-x-3">
//                         <button
//                           onClick={() => rejectRequest(request.id)}
//                           className="bg-white text-gray-700 px-4 py-2 rounded-lg border border-gray-300 hover:bg-gray-50"
//                         >
//                           Reject
//                         </button>
//                         <button
//                           onClick={() => approveRequest(request.id)}
//                           className="bg-black text-white px-4 py-2 rounded-lg hover:bg-gray-800"
//                         >
//                           Approve & Send to Vendor
//                         </button>
//                       </div>
//                     </div>
//                   ))}
//                 </div>
//               )}
//             </div>
//           )}
//         </div>
//       </div>

//       {/* Create PO Modal */}
//       {showCreatePOModal && (
//         <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center p-4 z-50">
//           <div className="bg-white rounded-lg max-w-4xl w-full max-h-[90vh] overflow-y-auto">
//             <div className="p-6">
//               <div className="flex justify-between items-center mb-4">
//                 <h2 className="text-xl font-bold">Create Purchase Order</h2>
//                 <button
//                   onClick={() => {
//                     setShowCreatePOModal(false);
//                     resetPoForm();
//                   }}
//                   className="text-gray-400 hover:text-gray-600"
//                 >
//                   <svg className="w-6 h-6" fill="none" stroke="currentColor" viewBox="0 0 24 24">
//                     <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M6 18L18 6M6 6l12 12" />
//                   </svg>
//                 </button>
//               </div>

//               <form onSubmit={createPurchaseOrder}>
//                 <div className="grid grid-cols-1 md:grid-cols-2 gap-4 mb-4">
//                   <div>
//                     <label className="block text-sm font-medium text-gray-700 mb-1">Vendor *</label>
//                     <select
//                       required
//                       className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-black focus:border-transparent"
//                       value={poForm.vendor}
//                       onChange={(e) => setPoForm({ ...poForm, vendor: e.target.value })}
//                     >
//                       <option value="">Select Vendor</option>
//                       {vendors.map(vendor => (
//                         <option key={vendor.id} value={vendor.name}>{vendor.name}</option>
//                       ))}
//                     </select>
//                   </div>
//                   <div>
//                     <label className="block text-sm font-medium text-gray-700 mb-1">Department *</label>
//                     <select
//                       required
//                       className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-black focus:border-transparent"
//                       value={poForm.department}
//                       onChange={(e) => setPoForm({ ...poForm, department: e.target.value })}
//                     >
//                       <option value="">Select Department</option>
//                       <option value="Housekeeping">Housekeeping</option>
//                       <option value="Kitchen">Kitchen</option>
//                       <option value="Front Desk">Front Desk</option>
//                       <option value="Maintenance">Maintenance</option>
//                     </select>
//                   </div>
//                   <div>
//                     <label className="block text-sm font-medium text-gray-700 mb-1">Required Date *</label>
//                     <input
//                       type="date"
//                       required
//                       className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-black focus:border-transparent"
//                       value={poForm.dateRequired}
//                       onChange={(e) => setPoForm({ ...poForm, dateRequired: e.target.value })}
//                     />
//                   </div>
//                   <div>
//                     <label className="block text-sm font-medium text-gray-700 mb-1">Priority</label>
//                     <select
//                       className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-black focus:border-transparent"
//                       value={poForm.priority}
//                       onChange={(e) => setPoForm({ ...poForm, priority: e.target.value })}
//                     >
//                       <option value="low">Low</option>
//                       <option value="medium">Medium</option>
//                       <option value="high">High</option>
//                     </select>
//                   </div>
//                 </div>

//                 <div className="mb-4">
//                   <div className="flex justify-between items-center mb-2">
//                     <label className="block text-sm font-medium text-gray-700">Items *</label>
//                     <button
//                       type="button"
//                       onClick={() => addItem(false)}
//                       className="text-blue-600 hover:text-blue-800 text-sm"
//                     >
//                       + Add Item
//                     </button>
//                   </div>
//                   {poForm.items.map((item, index) => (
//                     <div key={index} className="flex gap-2 mb-2">
//                       <input
//                         type="text"
//                         placeholder="Item name"
//                         className="flex-1 px-3 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-black focus:border-transparent"
//                         value={item.name}
//                         onChange={(e) => updateItem(index, 'name', e.target.value, false)}
//                         required
//                       />
//                       <input
//                         type="number"
//                         placeholder="Qty"
//                         className="w-20 px-3 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-black focus:border-transparent"
//                         value={item.quantity}
//                         onChange={(e) => updateItem(index, 'quantity', parseInt(e.target.value), false)}
//                         min="1"
//                         required
//                       />
//                       <input
//                         type="number"
//                         step="0.01"
//                         placeholder="Price"
//                         className="w-32 px-3 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-black focus:border-transparent"
//                         value={item.unitPrice}
//                         onChange={(e) => updateItem(index, 'unitPrice', parseFloat(e.target.value), false)}
//                         min="0"
//                         required
//                       />
//                       {poForm.items.length > 1 && (
//                         <button
//                           type="button"
//                           onClick={() => removeItem(index, false)}
//                           className="text-red-600 hover:text-red-800 px-2"
//                         >
//                           ×
//                         </button>
//                       )}
//                     </div>
//                   ))}
//                 </div>

//                 <div className="flex justify-between items-center mb-4">
//                   <div className="text-lg font-semibold">
//                     Total: ${calculateTotal(poForm.items).toFixed(2)}
//                   </div>
//                 </div>

//                 <div className="flex justify-end space-x-3 pt-4 border-t">
//                   <button
//                     type="button"
//                     onClick={() => {
//                       setShowCreatePOModal(false);
//                       resetPoForm();
//                     }}
//                     className="bg-white text-gray-700 px-4 py-2 rounded-lg border border-gray-300 hover:bg-gray-50"
//                   >
//                     Cancel
//                   </button>
//                   <button
//                     type="submit"
//                     className="bg-black text-white px-4 py-2 rounded-lg hover:bg-gray-800"
//                   >
//                     Create & Send to Vendor
//                   </button>
//                 </div>
//               </form>
//             </div>
//           </div>
//         </div>
//       )}

//       {/* Request PO Modal */}
//       {showRequestPOModal && (
//         <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center p-4 z-50">
//           <div className="bg-white rounded-lg max-w-4xl w-full max-h-[90vh] overflow-y-auto">
//             <div className="p-6">
//               <div className="flex justify-between items-center mb-4">
//                 <h2 className="text-xl font-bold">Request Purchase Order</h2>
//                 <button
//                   onClick={() => {
//                     setShowRequestPOModal(false);
//                     resetRequestForm();
//                   }}
//                   className="text-gray-400 hover:text-gray-600"
//                 >
//                   <svg className="w-6 h-6" fill="none" stroke="currentColor" viewBox="0 0 24 24">
//                     <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M6 18L18 6M6 6l12 12" />
//                   </svg>
//                 </button>
//               </div>

//               <form onSubmit={submitPurchaseRequest}>
//                 <div className="grid grid-cols-1 md:grid-cols-2 gap-4 mb-4">
//                   <div>
//                     <label className="block text-sm font-medium text-gray-700 mb-1">Vendor *</label>
//                     <select
//                       required
//                       className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-black focus:border-transparent"
//                       value={requestForm.vendor}
//                       onChange={(e) => setRequestForm({ ...requestForm, vendor: e.target.value })}
//                     >
//                       <option value="">Select Vendor</option>
//                       {vendors.map(vendor => (
//                         <option key={vendor.id} value={vendor.name}>{vendor.name}</option>
//                       ))}
//                     </select>
//                   </div>
//                   <div>
//                     <label className="block text-sm font-medium text-gray-700 mb-1">Department *</label>
//                     <select
//                       required
//                       className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-black focus:border-transparent"
//                       value={requestForm.department}
//                       onChange={(e) => setRequestForm({ ...requestForm, department: e.target.value })}
//                     >
//                       <option value="">Select Department</option>
//                       <option value="Housekeeping">Housekeeping</option>
//                       <option value="Kitchen">Kitchen</option>
//                       <option value="Front Desk">Front Desk</option>
//                       <option value="Maintenance">Maintenance</option>
//                     </select>
//                   </div>
//                   <div>
//                     <label className="block text-sm font-medium text-gray-700 mb-1">Required Date *</label>
//                     <input
//                       type="date"
//                       required
//                       className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-black focus:border-transparent"
//                       value={requestForm.dateRequired}
//                       onChange={(e) => setRequestForm({ ...requestForm, dateRequired: e.target.value })}
//                     />
//                   </div>
//                   <div>
//                     <label className="block text-sm font-medium text-gray-700 mb-1">Priority</label>
//                     <select
//                       className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-black focus:border-transparent"
//                       value={requestForm.priority}
//                       onChange={(e) => setRequestForm({ ...requestForm, priority: e.target.value })}
//                     >
//                       <option value="low">Low</option>
//                       <option value="medium">Medium</option>
//                       <option value="high">High</option>
//                     </select>
//                   </div>
//                 </div>

//                 <div className="mb-4">
//                   <label className="block text-sm font-medium text-gray-700 mb-1">Reason for Request *</label>
//                   <textarea
//                     className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-black focus:border-transparent"
//                     rows="3"
//                     value={requestForm.reason}
//                     onChange={(e) => setRequestForm({ ...requestForm, reason: e.target.value })}
//                     placeholder="Explain why these items are needed..."
//                     required
//                   />
//                 </div>

//                 <div className="mb-4">
//                   <div className="flex justify-between items-center mb-2">
//                     <label className="block text-sm font-medium text-gray-700">Items Needed *</label>
//                     <button
//                       type="button"
//                       onClick={() => addItem(true)}
//                       className="text-blue-600 hover:text-blue-800 text-sm"
//                     >
//                       + Add Item
//                     </button>
//                   </div>
//                   {requestForm.items.map((item, index) => (
//                     <div key={index} className="flex gap-2 mb-2">
//                       <input
//                         type="text"
//                         placeholder="Item name"
//                         className="flex-1 px-3 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-black focus:border-transparent"
//                         value={item.name}
//                         onChange={(e) => updateItem(index, 'name', e.target.value, true)}
//                         required
//                       />
//                       <input
//                         type="number"
//                         placeholder="Qty"
//                         className="w-20 px-3 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-black focus:border-transparent"
//                         value={item.quantity}
//                         onChange={(e) => updateItem(index, 'quantity', parseInt(e.target.value), true)}
//                         min="1"
//                         required
//                       />
//                       <input
//                         type="number"
//                         step="0.01"
//                         placeholder="Price"
//                         className="w-32 px-3 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-black focus:border-transparent"
//                         value={item.unitPrice}
//                         onChange={(e) => updateItem(index, 'unitPrice', parseFloat(e.target.value), true)}
//                         min="0"
//                         required
//                       />
//                       {requestForm.items.length > 1 && (
//                         <button
//                           type="button"
//                           onClick={() => removeItem(index, true)}
//                           className="text-red-600 hover:text-red-800 px-2"
//                         >
//                           ×
//                         </button>
//                       )}
//                     </div>
//                   ))}
//                 </div>

//                 <div className="flex justify-between items-center mb-4">
//                   <div className="text-lg font-semibold">
//                     Total: ${calculateTotal(requestForm.items).toFixed(2)}
//                   </div>
//                 </div>

//                 <div className="flex justify-end space-x-3 pt-4 border-t">
//                   <button
//                     type="button"
//                     onClick={() => {
//                       setShowRequestPOModal(false);
//                       resetRequestForm();
//                     }}
//                     className="bg-white text-gray-700 px-4 py-2 rounded-lg border border-gray-300 hover:bg-gray-50"
//                   >
//                     Cancel
//                   </button>
//                   <button
//                     type="submit"
//                     className="bg-black text-white px-4 py-2 rounded-lg hover:bg-gray-800"
//                   >
//                     Submit for Approval
//                   </button>
//                 </div>
//               </form>
//             </div>
//           </div>
//         </div>
//       )}
//       </div>
//     </div>
//   );
// };

// export default SupplyChainAndProcurement;

import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';

const SupplyChainAndProcurement = () => {
  const [activeTab, setActiveTab] = useState('directory');
  const [vendors, setVendors] = useState([]);
  const [selectedVendor, setSelectedVendor] = useState(null);
  const [searchTerm, setSearchTerm] = useState('');
  const [showCreatePOModal, setShowCreatePOModal] = useState(false);
  const [showRequestPOModal, setShowRequestPOModal] = useState(false);
  const [vendorOrders, setVendorOrders] = useState([]);
  const [vendorPayments, setVendorPayments] = useState([]);
  const [pendingApprovals, setPendingApprovals] = useState([]);

  // New states for popups and tracking
  const [showOrderDetails, setShowOrderDetails] = useState(false);
  const [selectedOrder, setSelectedOrder] = useState(null);
  const [showTrackingModal, setShowTrackingModal] = useState(false);
  const [showPaymentModal, setShowPaymentModal] = useState(false);
  const [selectedPayment, setSelectedPayment] = useState(null);

  const navigate = useNavigate();

  // Form states
  const [poForm, setPoForm] = useState({
    vendor: '',
    department: '',
    items: [{ name: '', quantity: 1, unitPrice: 0 }],
    dateRequired: '',
    priority: 'medium',
  });

  const [requestForm, setRequestForm] = useState({
    vendor: '',
    department: '',
    items: [{ name: '', quantity: 1, unitPrice: 0 }],
    dateRequired: '',
    reason: '',
    priority: 'medium',
  });

  // Payment form state
  const [paymentForm, setPaymentForm] = useState({
    amount: 0,
    paymentDate: '',
    paymentMethod: '',
    referenceNumber: '',
    notes: '',
    isPartial: false,
  });

  // Convert to INR function
  const formatINR = (amount) => {
    return new Intl.NumberFormat('en-IN', {
      style: 'currency',
      currency: 'INR',
      minimumFractionDigits: 2,
      maximumFractionDigits: 2,
    }).format(amount);
  };

  // Sample data - This would come from your master data management
  useEffect(() => {
    // Vendors data from master data
    setVendors([
      {
        id: 1,
        name: 'ABC Cleaning Supplies',
        contactPerson: 'John Doe',
        email: 'john@abccleaning.com',
        phone: '+91-98765-43210',
        address: '123 Industrial Ave, Mumbai, MH 400001',
        category: 'Cleaning Supplies',
        paymentTerms: 'Net 30',
        taxId: '12-3456789',
        bankAccount: '****1234',
        rating: 4.5,
        totalOrders: 47,
        totalSpend: 125000,
        onTimeDelivery: 92,
        qualityRating: 4.3,
        status: 'active',
        dateAdded: '2023-01-15',
      },
      {
        id: 2,
        name: 'Hotel Linens Inc',
        contactPerson: 'Sarah Smith',
        email: 'sarah@hotellinens.com',
        phone: '+91-98765-43211',
        address: '456 Textile Road, Delhi, DL 110001',
        category: 'Linens & Textiles',
        paymentTerms: 'Net 45',
        taxId: '98-7654321',
        bankAccount: '****5678',
        rating: 4.8,
        totalOrders: 32,
        totalSpend: 89000,
        onTimeDelivery: 96,
        qualityRating: 4.7,
        status: 'active',
        dateAdded: '2023-02-20',
      },
      {
        id: 3,
        name: 'Kitchen Equipment Co',
        contactPerson: 'Mike Johnson',
        email: 'mike@kitchenequip.com',
        phone: '+91-98765-43212',
        address: '789 Culinary Street, Bangalore, KA 560001',
        category: 'Kitchen Equipment',
        paymentTerms: 'Net 30',
        taxId: '45-6789012',
        bankAccount: '****9012',
        rating: 4.2,
        totalOrders: 28,
        totalSpend: 215000,
        onTimeDelivery: 88,
        qualityRating: 4.1,
        status: 'active',
        dateAdded: '2023-03-10',
      },
    ]);

    // Existing orders with tracking data
    setVendorOrders([
      {
        id: 'PO-2024-001',
        vendorId: 1,
        vendorName: 'ABC Cleaning Supplies',
        items: [
          { name: 'Brooms', quantity: 5, unitPrice: 159.99 },
          { name: 'Cleaning Cloths', quantity: 20, unitPrice: 25.5 },
        ],
        total: 2598.85,
        status: 'delivered',
        orderDate: '2024-01-15',
        deliveryDate: '2024-01-18',
        expectedDate: '2024-01-20',
        approvedBy: 'David Chen',
        type: 'direct',
        tracking: {
          steps: [
            { status: 'ordered', date: '2024-01-15', description: 'Order placed with vendor' },
            { status: 'confirmed', date: '2024-01-16', description: 'Vendor confirmed order' },
            { status: 'shipped', date: '2024-01-17', description: 'Order shipped via Delhivery' },
            {
              status: 'delivered',
              date: '2024-01-18',
              description: 'Order delivered successfully',
            },
          ],
          trackingNumber: 'DEL123456789',
          carrier: 'Delhivery',
          estimatedDelivery: '2024-01-20',
        },
      },
      {
        id: 'PO-2024-002',
        vendorId: 2,
        vendorName: 'Hotel Linens Inc',
        items: [{ name: 'Queen Bed Sheets', quantity: 50, unitPrice: 250.0 }],
        total: 12500.0,
        status: 'shipped',
        orderDate: '2024-01-16',
        deliveryDate: '',
        expectedDate: '2024-01-25',
        approvedBy: 'David Chen',
        type: 'direct',
        tracking: {
          steps: [
            { status: 'ordered', date: '2024-01-16', description: 'Order placed with vendor' },
            { status: 'confirmed', date: '2024-01-17', description: 'Vendor confirmed order' },
            { status: 'shipped', date: '2024-01-20', description: 'Order shipped via BlueDart' },
          ],
          trackingNumber: 'BLU987654321',
          carrier: 'BlueDart',
          estimatedDelivery: '2024-01-25',
        },
      },
      {
        id: 'PO-2024-003',
        vendorId: 3,
        vendorName: 'Kitchen Equipment Co',
        items: [
          { name: 'Chef Knives', quantity: 10, unitPrice: 450.0 },
          { name: 'Cutting Boards', quantity: 15, unitPrice: 225.5 },
        ],
        total: 7882.5,
        status: 'ordered',
        orderDate: '2024-01-18',
        deliveryDate: '',
        expectedDate: '2024-01-30',
        approvedBy: 'Manager User',
        type: 'approved',
        tracking: {
          steps: [
            { status: 'ordered', date: '2024-01-18', description: 'Order placed with vendor' },
            { status: 'confirmed', date: '2024-01-19', description: 'Vendor confirmed order' },
          ],
          trackingNumber: 'Pending',
          carrier: 'To be assigned',
          estimatedDelivery: '2024-01-30',
        },
      },
    ]);

    // Pending approvals for manager
    setPendingApprovals([
      {
        id: 'PR-2024-004',
        vendorId: 3,
        vendorName: 'Kitchen Equipment Co',
        requestedBy: 'Maria Garcia',
        department: 'Kitchen',
        items: [{ name: 'Mixer Grinder', quantity: 5, unitPrice: 3500.0 }],
        total: 17500.0,
        status: 'pending',
        dateRequested: '2024-01-22',
        dateRequired: '2024-02-05',
        reason: 'New kitchen equipment requirement',
        priority: 'high',
      },
    ]);

    // Vendor payments with partial payment support
    setVendorPayments([
      {
        id: 1,
        vendorId: 1,
        vendorName: 'ABC Cleaning Supplies',
        invoiceNumber: 'INV-001',
        amount: 2598.85,
        dueDate: '2024-02-15',
        status: 'paid',
        orderId: 'PO-2024-001',
        payments: [
          { amount: 2598.85, date: '2024-02-10', method: 'Bank Transfer', reference: 'BT123456' },
        ],
        balance: 0,
      },
      {
        id: 2,
        vendorId: 2,
        vendorName: 'Hotel Linens Inc',
        invoiceNumber: 'INV-002',
        amount: 12500.0,
        dueDate: '2024-02-28',
        status: 'partial',
        orderId: 'PO-2024-002',
        payments: [{ amount: 5000.0, date: '2024-02-15', method: 'UPI', reference: 'UPI987654' }],
        balance: 7500.0,
      },
      {
        id: 3,
        vendorId: 3,
        vendorName: 'Kitchen Equipment Co',
        invoiceNumber: 'INV-003',
        amount: 7882.5,
        dueDate: '2024-03-10',
        status: 'pending',
        orderId: 'PO-2024-003',
        payments: [],
        balance: 7882.5,
      },
    ]);
  }, []);

  // Filter vendors
  const filteredVendors = vendors.filter(
    (vendor) =>
      vendor.name.toLowerCase().includes(searchTerm.toLowerCase()) ||
      vendor.contactPerson.toLowerCase().includes(searchTerm.toLowerCase()) ||
      vendor.category.toLowerCase().includes(searchTerm.toLowerCase())
  );

  // Get vendor orders
  const getVendorOrders = (vendorId) => {
    return vendorOrders.filter((order) => order.vendorId === vendorId);
  };

  // Get vendor payments
  const getVendorPayments = (vendorId) => {
    return vendorPayments.filter((payment) => payment.vendorId === vendorId);
  };

  // Status badge component
  const StatusBadge = ({ status, type = 'order' }) => {
    const statusConfig = {
      order: {
        pending: { color: 'bg-yellow-100 text-yellow-800', text: 'Pending' },
        ordered: { color: 'bg-blue-100 text-blue-800', text: 'Ordered' },
        confirmed: { color: 'bg-purple-100 text-purple-800', text: 'Confirmed' },
        shipped: { color: 'bg-orange-100 text-orange-800', text: 'Shipped' },
        delivered: { color: 'bg-green-100 text-green-800', text: 'Delivered' },
        cancelled: { color: 'bg-red-100 text-red-800', text: 'Cancelled' },
      },
      payment: {
        pending: { color: 'bg-yellow-100 text-yellow-800', text: 'Pending' },
        partial: { color: 'bg-blue-100 text-blue-800', text: 'Partial Paid' },
        paid: { color: 'bg-green-100 text-green-800', text: 'Paid' },
        overdue: { color: 'bg-red-100 text-red-800', text: 'Overdue' },
      },
      approval: {
        pending: { color: 'bg-yellow-100 text-yellow-800', text: 'Pending Review' },
        approved: { color: 'bg-green-100 text-green-800', text: 'Approved' },
        rejected: { color: 'bg-red-100 text-red-800', text: 'Rejected' },
      },
    };

    const config = statusConfig[type][status] || statusConfig.order.pending;
    return (
      <span className={`px-2 py-1 rounded-full text-xs font-medium ${config.color}`}>
        {config.text}
      </span>
    );
  };

  // Rating stars component
  const RatingStars = ({ rating }) => {
    return (
      <div className="flex items-center">
        {[1, 2, 3, 4, 5].map((star) => (
          <svg
            key={star}
            className={`w-4 h-4 ${star <= rating ? 'text-yellow-400' : 'text-gray-300'}`}
            fill="currentColor"
            viewBox="0 0 20 20"
          >
            <path d="M9.049 2.927c.3-.921 1.603-.921 1.902 0l1.07 3.292a1 1 0 00.95.69h3.462c.969 0 1.371 1.24.588 1.81l-2.8 2.034a1 1 0 00-.364 1.118l1.07 3.292c.3.921-.755 1.688-1.54 1.118l-2.8-2.034a1 1 0 00-1.175 0l-2.8 2.034c-.784.57-1.838-.197-1.539-1.118l1.07-3.292a1 1 0 00-.364-1.118L2.98 8.72c-.783-.57-.38-1.81.588-1.81h3.461a1 1 0 00.951-.69l1.07-3.292z" />
          </svg>
        ))}
      </div>
    );
  };

  // Item management functions
  const addItem = (isRequest = false) => {
    if (isRequest) {
      setRequestForm({
        ...requestForm,
        items: [...requestForm.items, { name: '', quantity: 1, unitPrice: 0 }],
      });
    } else {
      setPoForm({
        ...poForm,
        items: [...poForm.items, { name: '', quantity: 1, unitPrice: 0 }],
      });
    }
  };

  const updateItem = (index, field, value, isRequest = false) => {
    if (isRequest) {
      const updatedItems = requestForm.items.map((item, i) =>
        i === index ? { ...item, [field]: value } : item
      );
      setRequestForm({ ...requestForm, items: updatedItems });
    } else {
      const updatedItems = poForm.items.map((item, i) =>
        i === index ? { ...item, [field]: value } : item
      );
      setPoForm({ ...poForm, items: updatedItems });
    }
  };

  const removeItem = (index, isRequest = false) => {
    if (isRequest) {
      const updatedItems = requestForm.items.filter((_, i) => i !== index);
      setRequestForm({ ...requestForm, items: updatedItems });
    } else {
      const updatedItems = poForm.items.filter((_, i) => i !== index);
      setPoForm({ ...poForm, items: updatedItems });
    }
  };

  const calculateTotal = (items) => {
    return items.reduce((total, item) => total + item.quantity * item.unitPrice, 0);
  };

  // Action functions
  const createPurchaseOrder = (e) => {
    e.preventDefault();
    const newOrder = {
      id: `PO-2024-00${vendorOrders.length + 1}`,
      vendorId: vendors.find((v) => v.name === poForm.vendor)?.id,
      vendorName: poForm.vendor,
      items: poForm.items,
      total: calculateTotal(poForm.items),
      status: 'ordered',
      orderDate: new Date().toISOString().split('T')[0],
      expectedDate: poForm.dateRequired,
      approvedBy: 'Admin User',
      type: 'direct',
      tracking: {
        steps: [
          {
            status: 'ordered',
            date: new Date().toISOString().split('T')[0],
            description: 'Order placed with vendor',
          },
        ],
        trackingNumber: 'Pending',
        carrier: 'To be assigned',
        estimatedDelivery: poForm.dateRequired,
      },
    };

    setVendorOrders([newOrder, ...vendorOrders]);

    // Create corresponding payment record
    const newPayment = {
      id: vendorPayments.length + 1,
      vendorId: vendors.find((v) => v.name === poForm.vendor)?.id,
      vendorName: poForm.vendor,
      invoiceNumber: `INV-00${vendorPayments.length + 1}`,
      amount: calculateTotal(poForm.items),
      dueDate: new Date(Date.now() + 30 * 24 * 60 * 60 * 1000).toISOString().split('T')[0], // 30 days from now
      status: 'pending',
      orderId: newOrder.id,
      payments: [],
      balance: calculateTotal(poForm.items),
    };

    setVendorPayments([newPayment, ...vendorPayments]);

    // Send to vendor (simulated)
    const vendor = vendors.find((v) => v.name === poForm.vendor);
    alert(`PO created and sent to ${vendor.name} at ${vendor.email}`);

    setShowCreatePOModal(false);
    resetPoForm();
  };

  const submitPurchaseRequest = (e) => {
    e.preventDefault();
    const newRequest = {
      id: `PR-2024-00${pendingApprovals.length + 1}`,
      vendorId: vendors.find((v) => v.name === requestForm.vendor)?.id,
      vendorName: requestForm.vendor,
      requestedBy: 'Staff User',
      department: requestForm.department,
      items: requestForm.items,
      total: calculateTotal(requestForm.items),
      status: 'pending',
      dateRequested: new Date().toISOString().split('T')[0],
      dateRequired: requestForm.dateRequired,
      reason: requestForm.reason,
      priority: requestForm.priority,
    };

    setPendingApprovals([newRequest, ...pendingApprovals]);
    alert('Purchase request submitted for manager approval');

    setShowRequestPOModal(false);
    resetRequestForm();
  };

  const approveRequest = (requestId) => {
    const request = pendingApprovals.find((req) => req.id === requestId);
    if (request) {
      const newOrder = {
        ...request,
        id: request.id.replace('PR', 'PO'),
        status: 'ordered',
        approvedBy: 'Manager User',
        type: 'approved',
        orderDate: new Date().toISOString().split('T')[0],
        tracking: {
          steps: [
            {
              status: 'ordered',
              date: new Date().toISOString().split('T')[0],
              description: 'Order placed with vendor',
            },
          ],
          trackingNumber: 'Pending',
          carrier: 'To be assigned',
          estimatedDelivery: request.dateRequired,
        },
      };

      setVendorOrders([newOrder, ...vendorOrders]);
      setPendingApprovals(pendingApprovals.filter((req) => req.id !== requestId));

      // Create corresponding payment record
      const newPayment = {
        id: vendorPayments.length + 1,
        vendorId: request.vendorId,
        vendorName: request.vendorName,
        invoiceNumber: `INV-00${vendorPayments.length + 1}`,
        amount: request.total,
        dueDate: new Date(Date.now() + 30 * 24 * 60 * 60 * 1000).toISOString().split('T')[0],
        status: 'pending',
        orderId: newOrder.id,
        payments: [],
        balance: request.total,
      };

      setVendorPayments([newPayment, ...vendorPayments]);

      // Send to vendor (simulated)
      const vendor = vendors.find((v) => v.id === request.vendorId);
      alert(`PO approved and sent to ${vendor.name} at ${vendor.email}`);
    }
  };

  const rejectRequest = (requestId) => {
    setPendingApprovals(pendingApprovals.filter((req) => req.id !== requestId));
    alert('Purchase request rejected');
  };

  const updateOrderStatus = (orderId, newStatus) => {
    setVendorOrders(
      vendorOrders.map((order) => {
        if (order.id === orderId) {
          const updatedSteps = [...order.tracking.steps];
          if (
            newStatus === 'confirmed' &&
            !updatedSteps.find((step) => step.status === 'confirmed')
          ) {
            updatedSteps.push({
              status: 'confirmed',
              date: new Date().toISOString().split('T')[0],
              description: 'Vendor confirmed order',
            });
          } else if (
            newStatus === 'shipped' &&
            !updatedSteps.find((step) => step.status === 'shipped')
          ) {
            updatedSteps.push({
              status: 'shipped',
              date: new Date().toISOString().split('T')[0],
              description: 'Order shipped',
            });
          } else if (
            newStatus === 'delivered' &&
            !updatedSteps.find((step) => step.status === 'delivered')
          ) {
            updatedSteps.push({
              status: 'delivered',
              date: new Date().toISOString().split('T')[0],
              description: 'Order delivered successfully',
            });
          }

          return {
            ...order,
            status: newStatus,
            tracking: {
              ...order.tracking,
              steps: updatedSteps,
            },
          };
        }
        return order;
      })
    );
  };

  const processPayment = (e) => {
    e.preventDefault();
    const paymentAmount = parseFloat(paymentForm.amount);

    setVendorPayments(
      vendorPayments.map((payment) => {
        if (payment.id === selectedPayment.id) {
          const newPayments = [
            ...payment.payments,
            {
              amount: paymentAmount,
              date: paymentForm.paymentDate || new Date().toISOString().split('T')[0],
              method: paymentForm.paymentMethod,
              reference: paymentForm.referenceNumber,
              notes: paymentForm.notes,
            },
          ];

          const totalPaid = newPayments.reduce((sum, p) => sum + p.amount, 0);
          const newBalance = payment.amount - totalPaid;
          const newStatus = newBalance === 0 ? 'paid' : totalPaid > 0 ? 'partial' : 'pending';

          return {
            ...payment,
            payments: newPayments,
            balance: newBalance,
            status: newStatus,
          };
        }
        return payment;
      })
    );

    alert(`Payment of ${formatINR(paymentAmount)} processed successfully`);
    setShowPaymentModal(false);
    setSelectedPayment(null);
    setPaymentForm({
      amount: 0,
      paymentDate: '',
      paymentMethod: '',
      referenceNumber: '',
      notes: '',
      isPartial: false,
    });
  };

  const viewOrderDetails = (order) => {
    setSelectedOrder(order);
    setShowOrderDetails(true);
  };

  const viewTracking = (order) => {
    setSelectedOrder(order);
    setShowTrackingModal(true);
  };

  const viewPaymentDetails = (payment) => {
    setSelectedPayment(payment);
    setPaymentForm({
      amount: payment.balance,
      paymentDate: new Date().toISOString().split('T')[0],
      paymentMethod: '',
      referenceNumber: '',
      notes: '',
      isPartial: payment.balance < payment.amount,
    });
    setShowPaymentModal(true);
  };

  const resetPoForm = () => {
    setPoForm({
      vendor: '',
      department: '',
      items: [{ name: '', quantity: 1, unitPrice: 0 }],
      dateRequired: '',
      priority: 'medium',
    });
  };

  const resetRequestForm = () => {
    setRequestForm({
      vendor: '',
      department: '',
      items: [{ name: '', quantity: 1, unitPrice: 0 }],
      dateRequired: '',
      reason: '',
      priority: 'medium',
    });
  };

  // Tracking step component
  const TrackingStep = ({ step, isActive, isCompleted }) => {
    return (
      <div className="flex items-center">
        <div
          className={`flex-shrink-0 w-8 h-8 rounded-full flex items-center justify-center ${
            isCompleted ? 'bg-green-500' : isActive ? 'bg-blue-500' : 'bg-gray-300'
          }`}
        >
          {isCompleted ? (
            <svg
              className="w-4 h-4 text-white"
              fill="none"
              stroke="currentColor"
              viewBox="0 0 24 24"
            >
              <path
                strokeLinecap="round"
                strokeLinejoin="round"
                strokeWidth={2}
                d="M5 13l4 4L19 7"
              />
            </svg>
          ) : (
            <span className={`text-sm font-medium ${isActive ? 'text-white' : 'text-gray-600'}`}>
              {step.status.charAt(0).toUpperCase()}
            </span>
          )}
        </div>
        <div className="ml-4">
          <p className={`text-sm font-medium ${isActive ? 'text-gray-900' : 'text-gray-500'}`}>
            {step.status.charAt(0).toUpperCase() + step.status.slice(1)}
          </p>
          <p className="text-sm text-gray-500">{step.date}</p>
          <p className="text-xs text-gray-400">{step.description}</p>
        </div>
      </div>
    );
  };

  return (
    <div className="p-6 min-h-screen bg-gray-50">
      <header className="flex justify-between items-center mb-3 bg-white p-3">
        <h1 className="text-black text-xl font-bold ml-2">Supply Chain and Procurement</h1>
        <div className="flex space-x-6">
          <button
            onClick={() => navigate('/dashboard/core-modules/supply-chain/vendor-management')}
            className="btn text-black font-bold"
          >
            Vendor Management
          </button>
          <button
            onClick={() => navigate('/dashboard/core-modules/supply-chain/inventory-procurement')}
            className="btn"
          >
            Inventory and Procurement
          </button>
          <button
            onClick={() => navigate('/dashboard/core-modules/supply-chain/cost-control-budgeting')}
            className="btn"
          >
            Cost Control and Budgeting
          </button>
        </div>
      </header>
      <div className="px-4">
        {/* Header */}
        <div className="flex justify-between items-center mb-6">
          <div>
            <h1 className="text-2xl font-bold text-gray-900">Vendor Management</h1>
            <p className="text-gray-600">Manage vendor relationships, orders, and payments</p>
          </div>
          <div className="flex space-x-3">
            <button
              onClick={() => setShowRequestPOModal(true)}
              className="bg-white text-gray-700 px-4 py-2 rounded-lg border border-gray-300 hover:bg-gray-50 flex items-center"
            >
              <svg className="w-5 h-5 mr-2" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  strokeWidth={2}
                  d="M12 9v3m0 0v3m0-3h3m-3 0H9m12 0a9 9 0 11-18 0 9 9 0 0118 0z"
                />
              </svg>
              Request PO
            </button>
            <button
              onClick={() => setShowCreatePOModal(true)}
              className="bg-black text-white px-4 py-2 rounded-lg hover:bg-gray-800 flex items-center"
            >
              <svg className="w-5 h-5 mr-2" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  strokeWidth={2}
                  d="M12 4v16m8-8H4"
                />
              </svg>
              Create PO
            </button>
          </div>
        </div>

        {/* Stats Cards */}
        <div className="grid grid-cols-1 md:grid-cols-4 gap-6 mb-6">
          <div className="bg-white p-6 rounded-lg border border-gray-200">
            <div className="flex items-center">
              <div className="p-3 bg-gray-100 rounded-lg">
                <svg
                  className="w-6 h-6 text-gray-600"
                  fill="none"
                  stroke="currentColor"
                  viewBox="0 0 24 24"
                >
                  <path
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    strokeWidth={2}
                    d="M17 20h5v-2a3 3 0 00-5.356-1.857M17 20H7m10 0v-2c0-.656-.126-1.283-.356-1.857M7 20H2v-2a3 3 0 015.356-1.857M7 20v-2c0-.656.126-1.283.356-1.857m0 0a5.002 5.002 0 019.288 0M15 7a3 3 0 11-6 0 3 3 0 016 0zm6 3a2 2 0 11-4 0 2 2 0 014 0zM7 10a2 2 0 11-4 0 2 2 0 014 0z"
                  />
                </svg>
              </div>
              <div className="ml-4">
                <h3 className="text-2xl font-bold text-gray-900">{vendors.length}</h3>
                <p className="text-gray-600">Total Vendors</p>
              </div>
            </div>
          </div>

          <div className="bg-white p-6 rounded-lg border border-gray-200">
            <div className="flex items-center">
              <div className="p-3 bg-gray-100 rounded-lg">
                <svg
                  className="w-6 h-6 text-gray-600"
                  fill="none"
                  stroke="currentColor"
                  viewBox="0 0 24 24"
                >
                  <path
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    strokeWidth={2}
                    d="M9 5H7a2 2 0 00-2 2v12a2 2 0 002 2h10a2 2 0 002-2V7a2 2 0 00-2-2h-2M9 5a2 2 0 002 2h2a2 2 0 002-2M9 5a2 2 0 012-2h2a2 2 0 012 2"
                  />
                </svg>
              </div>
              <div className="ml-4">
                <h3 className="text-2xl font-bold text-gray-900">{vendorOrders.length}</h3>
                <p className="text-gray-600">Total Orders</p>
              </div>
            </div>
          </div>

          <div className="bg-white p-6 rounded-lg border border-gray-200">
            <div className="flex items-center">
              <div className="p-3 bg-gray-100 rounded-lg">
                <svg
                  className="w-6 h-6 text-gray-600"
                  fill="none"
                  stroke="currentColor"
                  viewBox="0 0 24 24"
                >
                  <path
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    strokeWidth={2}
                    d="M12 8c-1.657 0-3 .895-3 2s1.343 2 3 2 3 .895 3 2-1.343 2-3 2m0-8c1.11 0 2.08.402 2.599 1M12 8V7m0 1v8m0 0v1m0-1c-1.11 0-2.08-.402-2.599-1"
                  />
                </svg>
              </div>
              <div className="ml-4">
                <h3 className="text-2xl font-bold text-gray-900">
                  {formatINR(vendorPayments.reduce((sum, payment) => sum + payment.balance, 0))}
                </h3>
                <p className="text-gray-600">Pending Payments</p>
              </div>
            </div>
          </div>

          <div className="bg-white p-6 rounded-lg border border-gray-200">
            <div className="flex items-center">
              <div className="p-3 bg-gray-100 rounded-lg">
                <svg
                  className="w-6 h-6 text-gray-600"
                  fill="none"
                  stroke="currentColor"
                  viewBox="0 0 24 24"
                >
                  <path
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    strokeWidth={2}
                    d="M9 12l2 2 4-4m6 2a9 9 0 11-18 0 9 9 0 0118 0z"
                  />
                </svg>
              </div>
              <div className="ml-4">
                <h3 className="text-2xl font-bold text-gray-900">{pendingApprovals.length}</h3>
                <p className="text-gray-600">Pending Approvals</p>
              </div>
            </div>
          </div>
        </div>

        {/* Main Tabs */}
        <div className="bg-white rounded-lg border border-gray-200">
          <div className="border-b border-gray-200">
            <nav className="flex -mb-px">
              {['directory', 'orders', 'payments', 'approvals'].map((tab) => (
                <button
                  key={tab}
                  onClick={() => setActiveTab(tab)}
                  className={`py-4 px-6 font-medium text-sm border-b-2 transition-colors ${
                    activeTab === tab
                      ? 'border-black text-black'
                      : 'border-transparent text-gray-600 hover:text-black hover:border-gray-300'
                  }`}
                >
                  {tab.charAt(0).toUpperCase() + tab.slice(1).replace(/([A-Z])/g, ' $1')}
                  {tab === 'approvals' && pendingApprovals.length > 0 && (
                    <span className="ml-2 bg-red-500 text-white rounded-full px-2 py-1 text-xs">
                      {pendingApprovals.length}
                    </span>
                  )}
                </button>
              ))}
            </nav>
          </div>

          <div className="p-6">
            {/* Vendor Directory Tab */}
            {activeTab === 'directory' && (
              <div>
                <div className="flex justify-between items-center mb-6">
                  <div className="flex-1 max-w-md">
                    <div className="relative">
                      <input
                        type="text"
                        placeholder="Search vendors by name, contact, or category..."
                        className="w-full pl-10 pr-4 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-black focus:border-transparent"
                        value={searchTerm}
                        onChange={(e) => setSearchTerm(e.target.value)}
                      />
                      <svg
                        className="w-5 h-5 text-gray-400 absolute left-3 top-2.5"
                        fill="none"
                        stroke="currentColor"
                        viewBox="0 0 24 24"
                      >
                        <path
                          strokeLinecap="round"
                          strokeLinejoin="round"
                          strokeWidth={2}
                          d="M21 21l-6-6m2-5a7 7 0 11-14 0 7 7 0 0114 0z"
                        />
                      </svg>
                    </div>
                  </div>
                </div>

                <div className="grid grid-cols-1 md:grid-cols-2 xl:grid-cols-3 gap-6">
                  {filteredVendors.map((vendor) => (
                    <div
                      key={vendor.id}
                      className="bg-white border border-gray-200 rounded-lg p-6 hover:shadow-md transition-shadow"
                    >
                      <div className="flex justify-between items-start mb-4">
                        <div className="flex-1">
                          <h3 className="text-lg font-semibold text-gray-900 mb-1">
                            {vendor.name}
                          </h3>
                          <p className="text-sm text-gray-600 mb-2">{vendor.category}</p>
                          <div className="flex items-center space-x-2">
                            <span
                              className={`px-2 py-1 rounded-full text-xs font-medium ${
                                vendor.status === 'active'
                                  ? 'bg-green-100 text-green-800'
                                  : 'bg-gray-100 text-gray-800'
                              }`}
                            >
                              {vendor.status}
                            </span>
                            <RatingStars rating={vendor.rating} />
                          </div>
                        </div>
                      </div>

                      <div className="space-y-2 mb-4">
                        <div className="flex items-center text-sm text-gray-600">
                          <svg
                            className="w-4 h-4 mr-2 flex-shrink-0"
                            fill="none"
                            stroke="currentColor"
                            viewBox="0 0 24 24"
                          >
                            <path
                              strokeLinecap="round"
                              strokeLinejoin="round"
                              strokeWidth={2}
                              d="M16 7a4 4 0 11-8 0 4 4 0 018 0zM12 14a7 7 0 00-7 7h14a7 7 0 00-7-7z"
                            />
                          </svg>
                          {vendor.contactPerson}
                        </div>
                        <div className="flex items-center text-sm text-gray-600">
                          <svg
                            className="w-4 h-4 mr-2 flex-shrink-0"
                            fill="none"
                            stroke="currentColor"
                            viewBox="0 0 24 24"
                          >
                            <path
                              strokeLinecap="round"
                              strokeLinejoin="round"
                              strokeWidth={2}
                              d="M3 8l7.89 5.26a2 2 0 002.22 0L21 8M5 19h14a2 2 0 002-2V7a2 2 0 00-2-2H5a2 2 0 00-2 2v10a2 2 0 002 2z"
                            />
                          </svg>
                          {vendor.email}
                        </div>
                        <div className="flex items-center text-sm text-gray-600">
                          <svg
                            className="w-4 h-4 mr-2 flex-shrink-0"
                            fill="none"
                            stroke="currentColor"
                            viewBox="0 0 24 24"
                          >
                            <path
                              strokeLinecap="round"
                              strokeLinejoin="round"
                              strokeWidth={2}
                              d="M3 5a2 2 0 012-2h3.28a1 1 0 01.948.684l1.498 4.493a1 1 0 01-.502 1.21l-2.257 1.13a11.042 11.042 0 005.516 5.516l1.13-2.257a1 1 0 011.21-.502l4.493 1.498a1 1 0 01.684.949V19a2 2 0 01-2 2h-1C9.716 21 3 14.284 3 6V5z"
                            />
                          </svg>
                          {vendor.phone}
                        </div>
                      </div>

                      <div className="grid grid-cols-2 gap-4 mb-4 text-center">
                        <div>
                          <div className="text-sm font-semibold text-gray-900">
                            {vendor.totalOrders}
                          </div>
                          <div className="text-xs text-gray-600">Total Orders</div>
                        </div>
                        <div>
                          <div className="text-sm font-semibold text-green-600">
                            {vendor.onTimeDelivery}%
                          </div>
                          <div className="text-xs text-gray-600">On-Time Delivery</div>
                        </div>
                      </div>

                      <div className="flex space-x-2">
                        <button
                          onClick={() => {
                            setPoForm({ ...poForm, vendor: vendor.name });
                            setShowCreatePOModal(true);
                          }}
                          className="flex-1 bg-black text-white px-3 py-2 rounded text-sm hover:bg-gray-800 transition-colors"
                        >
                          Create PO
                        </button>
                        <button
                          onClick={() => {
                            setSelectedVendor(vendor);
                            setActiveTab('orders');
                          }}
                          className="flex-1 bg-white text-gray-700 px-3 py-2 rounded text-sm border border-gray-300 hover:bg-gray-50 transition-colors"
                        >
                          View Orders
                        </button>
                      </div>
                    </div>
                  ))}
                </div>
              </div>
            )}

            {/* Orders Tab */}
            {activeTab === 'orders' && (
              <div>
                <div className="flex justify-between items-center mb-6">
                  <h2 className="text-xl font-semibold text-gray-900">Purchase Orders</h2>
                  <div className="flex space-x-3">
                    <button
                      onClick={() => setShowRequestPOModal(true)}
                      className="bg-white text-gray-700 px-4 py-2 rounded-lg border border-gray-300 hover:bg-gray-50"
                    >
                      Request PO
                    </button>
                    <button
                      onClick={() => setShowCreatePOModal(true)}
                      className="bg-black text-white px-4 py-2 rounded-lg hover:bg-gray-800"
                    >
                      Create PO
                    </button>
                  </div>
                </div>

                <div className="overflow-x-auto">
                  <table className="w-full">
                    <thead>
                      <tr className="bg-gray-50">
                        <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">
                          PO Number
                        </th>
                        <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">
                          Vendor
                        </th>
                        <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">
                          Order Date
                        </th>
                        <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">
                          Total
                        </th>
                        <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">
                          Status
                        </th>
                        <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">
                          Type
                        </th>
                        <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">
                          Actions
                        </th>
                      </tr>
                    </thead>
                    <tbody className="bg-white divide-y divide-gray-200">
                      {vendorOrders.map((order) => (
                        <tr key={order.id} className="hover:bg-gray-50">
                          <td className="px-6 py-4 whitespace-nowrap">
                            <div className="text-sm font-medium text-gray-900">{order.id}</div>
                          </td>
                          <td className="px-6 py-4 whitespace-nowrap">
                            <div className="text-sm text-gray-900">{order.vendorName}</div>
                          </td>
                          <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-500">
                            {order.orderDate}
                          </td>
                          <td className="px-6 py-4 whitespace-nowrap text-sm font-medium text-gray-900">
                            {formatINR(order.total)}
                          </td>
                          <td className="px-6 py-4 whitespace-nowrap">
                            <StatusBadge status={order.status} type="order" />
                          </td>
                          <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-500">
                            <span
                              className={`px-2 py-1 rounded-full text-xs ${
                                order.type === 'direct'
                                  ? 'bg-blue-100 text-blue-800'
                                  : 'bg-green-100 text-green-800'
                              }`}
                            >
                              {order.type}
                            </span>
                          </td>
                          <td className="px-6 py-4 whitespace-nowrap text-sm font-medium">
                            <button
                              onClick={() => viewOrderDetails(order)}
                              className="text-blue-600 hover:text-blue-800 mr-3"
                            >
                              View
                            </button>
                            <button
                              onClick={() => viewTracking(order)}
                              className="text-green-600 hover:text-green-800 mr-3"
                            >
                              Track
                            </button>
                            {order.status === 'ordered' && (
                              <button
                                onClick={() => updateOrderStatus(order.id, 'confirmed')}
                                className="text-purple-600 hover:text-purple-800"
                              >
                                Confirm
                              </button>
                            )}
                            {order.status === 'confirmed' && (
                              <button
                                onClick={() => updateOrderStatus(order.id, 'shipped')}
                                className="text-orange-600 hover:text-orange-800"
                              >
                                Ship
                              </button>
                            )}
                            {order.status === 'shipped' && (
                              <button
                                onClick={() => updateOrderStatus(order.id, 'delivered')}
                                className="text-green-600 hover:text-green-800"
                              >
                                Deliver
                              </button>
                            )}
                          </td>
                        </tr>
                      ))}
                    </tbody>
                  </table>
                </div>
              </div>
            )}

            {/* Payments Tab */}
            {activeTab === 'payments' && (
              <div>
                <h2 className="text-xl font-semibold text-gray-900 mb-6">Vendor Payments</h2>
                <div className="overflow-x-auto">
                  <table className="w-full">
                    <thead>
                      <tr className="bg-gray-50">
                        <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">
                          Invoice
                        </th>
                        <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">
                          Vendor
                        </th>
                        <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">
                          Amount
                        </th>
                        <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">
                          Balance
                        </th>
                        <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">
                          Due Date
                        </th>
                        <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">
                          Status
                        </th>
                        <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">
                          Actions
                        </th>
                      </tr>
                    </thead>
                    <tbody className="bg-white divide-y divide-gray-200">
                      {vendorPayments.map((payment) => (
                        <tr key={payment.id} className="hover:bg-gray-50">
                          <td className="px-6 py-4 whitespace-nowrap">
                            <div className="text-sm font-medium text-gray-900">
                              {payment.invoiceNumber}
                            </div>
                            <div className="text-sm text-gray-500">{payment.orderId}</div>
                          </td>
                          <td className="px-6 py-4 whitespace-nowrap">
                            <div className="text-sm text-gray-900">{payment.vendorName}</div>
                          </td>
                          <td className="px-6 py-4 whitespace-nowrap text-sm font-medium text-gray-900">
                            {formatINR(payment.amount)}
                          </td>
                          <td className="px-6 py-4 whitespace-nowrap text-sm font-medium text-gray-900">
                            {formatINR(payment.balance)}
                          </td>
                          <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-500">
                            {payment.dueDate}
                          </td>
                          <td className="px-6 py-4 whitespace-nowrap">
                            <StatusBadge status={payment.status} type="payment" />
                          </td>
                          <td className="px-6 py-4 whitespace-nowrap text-sm font-medium">
                            <button
                              onClick={() => viewPaymentDetails(payment)}
                              className="bg-black text-white px-3 py-1 rounded text-sm hover:bg-gray-800 mr-2"
                            >
                              {payment.balance > 0 ? 'Make Payment' : 'View Details'}
                            </button>
                            <button className="text-blue-600 hover:text-blue-800">View</button>
                          </td>
                        </tr>
                      ))}
                    </tbody>
                  </table>
                </div>
              </div>
            )}

            {/* Approvals Tab */}
            {activeTab === 'approvals' && (
              <div>
                <h2 className="text-xl font-semibold text-gray-900 mb-6">Pending Approvals</h2>
                {pendingApprovals.length === 0 ? (
                  <div className="text-center py-8">
                    <svg
                      className="w-12 h-12 text-gray-400 mx-auto mb-4"
                      fill="none"
                      stroke="currentColor"
                      viewBox="0 0 24 24"
                    >
                      <path
                        strokeLinecap="round"
                        strokeLinejoin="round"
                        strokeWidth={2}
                        d="M9 12l2 2 4-4m6 2a9 9 0 11-18 0 9 9 0 0118 0z"
                      />
                    </svg>
                    <p className="text-gray-500">No pending approvals</p>
                  </div>
                ) : (
                  <div className="space-y-4">
                    {pendingApprovals.map((request) => (
                      <div
                        key={request.id}
                        className="bg-yellow-50 border border-yellow-200 rounded-lg p-6"
                      >
                        <div className="flex justify-between items-start mb-4">
                          <div className="flex-1">
                            <div className="flex items-center space-x-3 mb-2">
                              <h3 className="text-lg font-semibold text-gray-900">{request.id}</h3>
                              <StatusBadge status={request.status} type="approval" />
                              <span
                                className={`px-2 py-1 rounded-full text-xs font-medium ${
                                  request.priority === 'high'
                                    ? 'bg-red-100 text-red-800'
                                    : request.priority === 'medium'
                                      ? 'bg-yellow-100 text-yellow-800'
                                      : 'bg-green-100 text-green-800'
                                }`}
                              >
                                {request.priority} priority
                              </span>
                            </div>
                            <p className="text-sm text-gray-600">
                              <strong>Vendor:</strong> {request.vendorName} |
                              <strong> Requested by:</strong> {request.requestedBy} (
                              {request.department}) |<strong> Required by:</strong>{' '}
                              {request.dateRequired}
                            </p>
                            <p className="text-sm text-gray-600 mt-1">
                              <strong>Reason:</strong> {request.reason}
                            </p>

                            <div className="mt-3">
                              <strong className="text-sm">Items:</strong>
                              <ul className="text-sm text-gray-600 ml-4 mt-1">
                                {request.items.map((item, index) => (
                                  <li key={index}>
                                    {item.quantity}x {item.name} - {formatINR(item.unitPrice)} each
                                  </li>
                                ))}
                              </ul>
                            </div>

                            <p className="text-sm font-semibold mt-2">
                              Total: {formatINR(request.total)}
                            </p>
                          </div>
                        </div>

                        <div className="flex justify-end space-x-3">
                          <button
                            onClick={() => rejectRequest(request.id)}
                            className="bg-white text-gray-700 px-4 py-2 rounded-lg border border-gray-300 hover:bg-gray-50"
                          >
                            Reject
                          </button>
                          <button
                            onClick={() => approveRequest(request.id)}
                            className="bg-black text-white px-4 py-2 rounded-lg hover:bg-gray-800"
                          >
                            Approve & Send to Vendor
                          </button>
                        </div>
                      </div>
                    ))}
                  </div>
                )}
              </div>
            )}
          </div>
        </div>

        {/* Order Details Modal */}
        {showOrderDetails && selectedOrder && (
          <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center p-4 z-50">
            <div className="bg-white rounded-lg max-w-4xl w-full max-h-[90vh] overflow-y-auto">
              <div className="p-6">
                <div className="flex justify-between items-center mb-4">
                  <h2 className="text-xl font-bold">Order Details - {selectedOrder.id}</h2>
                  <button
                    onClick={() => setShowOrderDetails(false)}
                    className="text-gray-400 hover:text-gray-600"
                  >
                    <svg className="w-6 h-6" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                      <path
                        strokeLinecap="round"
                        strokeLinejoin="round"
                        strokeWidth={2}
                        d="M6 18L18 6M6 6l12 12"
                      />
                    </svg>
                  </button>
                </div>

                <div className="grid grid-cols-1 md:grid-cols-2 gap-6 mb-6">
                  <div>
                    <h3 className="text-lg font-semibold mb-4">Order Information</h3>
                    <div className="space-y-3">
                      <div>
                        <label className="text-sm font-medium text-gray-600">Vendor</label>
                        <p className="text-gray-900">{selectedOrder.vendorName}</p>
                      </div>
                      <div>
                        <label className="text-sm font-medium text-gray-600">Order Date</label>
                        <p className="text-gray-900">{selectedOrder.orderDate}</p>
                      </div>
                      <div>
                        <label className="text-sm font-medium text-gray-600">Expected Date</label>
                        <p className="text-gray-900">{selectedOrder.expectedDate}</p>
                      </div>
                      <div>
                        <label className="text-sm font-medium text-gray-600">Status</label>
                        <p className="text-gray-900">
                          <StatusBadge status={selectedOrder.status} type="order" />
                        </p>
                      </div>
                      <div>
                        <label className="text-sm font-medium text-gray-600">Approved By</label>
                        <p className="text-gray-900">{selectedOrder.approvedBy}</p>
                      </div>
                    </div>
                  </div>

                  <div>
                    <h3 className="text-lg font-semibold mb-4">Order Items</h3>
                    <div className="border border-gray-200 rounded-lg">
                      <table className="w-full">
                        <thead className="bg-gray-50">
                          <tr>
                            <th className="px-4 py-2 text-left text-sm font-medium text-gray-700">
                              Item
                            </th>
                            <th className="px-4 py-2 text-left text-sm font-medium text-gray-700">
                              Qty
                            </th>
                            <th className="px-4 py-2 text-left text-sm font-medium text-gray-700">
                              Price
                            </th>
                            <th className="px-4 py-2 text-left text-sm font-medium text-gray-700">
                              Total
                            </th>
                          </tr>
                        </thead>
                        <tbody>
                          {selectedOrder.items.map((item, index) => (
                            <tr key={index} className="border-t border-gray-200">
                              <td className="px-4 py-3 text-sm text-gray-900">{item.name}</td>
                              <td className="px-4 py-3 text-sm text-gray-600">{item.quantity}</td>
                              <td className="px-4 py-3 text-sm text-gray-600">
                                {formatINR(item.unitPrice)}
                              </td>
                              <td className="px-4 py-3 text-sm font-medium text-gray-900">
                                {formatINR(item.quantity * item.unitPrice)}
                              </td>
                            </tr>
                          ))}
                        </tbody>
                        <tfoot className="bg-gray-50">
                          <tr>
                            <td
                              colSpan="3"
                              className="px-4 py-3 text-sm font-medium text-gray-900 text-right"
                            >
                              Total:
                            </td>
                            <td className="px-4 py-3 text-sm font-bold text-gray-900">
                              {formatINR(selectedOrder.total)}
                            </td>
                          </tr>
                        </tfoot>
                      </table>
                    </div>
                  </div>
                </div>

                <div className="flex justify-end">
                  <button
                    onClick={() => setShowOrderDetails(false)}
                    className="bg-black text-white px-4 py-2 rounded-lg hover:bg-gray-800"
                  >
                    Close
                  </button>
                </div>
              </div>
            </div>
          </div>
        )}

        {/* Tracking Modal */}
        {showTrackingModal && selectedOrder && (
          <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center p-4 z-50">
            <div className="bg-white rounded-lg max-w-2xl w-full max-h-[90vh] overflow-y-auto">
              <div className="p-6">
                <div className="flex justify-between items-center mb-6">
                  <h2 className="text-xl font-bold">Order Tracking - {selectedOrder.id}</h2>
                  <button
                    onClick={() => setShowTrackingModal(false)}
                    className="text-gray-400 hover:text-gray-600"
                  >
                    <svg className="w-6 h-6" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                      <path
                        strokeLinecap="round"
                        strokeLinejoin="round"
                        strokeWidth={2}
                        d="M6 18L18 6M6 6l12 12"
                      />
                    </svg>
                  </button>
                </div>

                <div className="mb-6">
                  <div className="flex justify-between items-center mb-4">
                    <div>
                      <h3 className="text-lg font-semibold">{selectedOrder.vendorName}</h3>
                      <p className="text-gray-600">
                        Tracking #: {selectedOrder.tracking.trackingNumber}
                      </p>
                    </div>
                    <StatusBadge status={selectedOrder.status} type="order" />
                  </div>

                  <div className="grid grid-cols-2 gap-4 mb-4">
                    <div>
                      <label className="text-sm font-medium text-gray-600">Carrier</label>
                      <p className="text-gray-900">{selectedOrder.tracking.carrier}</p>
                    </div>
                    <div>
                      <label className="text-sm font-medium text-gray-600">
                        Estimated Delivery
                      </label>
                      <p className="text-gray-900">{selectedOrder.tracking.estimatedDelivery}</p>
                    </div>
                  </div>
                </div>

                <div className="space-y-4">
                  <h3 className="text-lg font-semibold">Tracking History</h3>
                  <div className="space-y-6">
                    {selectedOrder.tracking.steps.map((step, index) => (
                      <TrackingStep
                        key={index}
                        step={step}
                        isActive={step.status === selectedOrder.status}
                        isCompleted={
                          index <
                            selectedOrder.tracking.steps.findIndex(
                              (s) => s.status === selectedOrder.status
                            ) ||
                          (selectedOrder.status === 'delivered' &&
                            index <= selectedOrder.tracking.steps.length - 1)
                        }
                      />
                    ))}
                  </div>
                </div>

                <div className="flex justify-end mt-6">
                  <button
                    onClick={() => setShowTrackingModal(false)}
                    className="bg-black text-white px-4 py-2 rounded-lg hover:bg-gray-800"
                  >
                    Close
                  </button>
                </div>
              </div>
            </div>
          </div>
        )}

        {/* Payment Modal */}
        {showPaymentModal && selectedPayment && (
          <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center p-4 z-50">
            <div className="bg-white rounded-lg max-w-2xl w-full max-h-[90vh] overflow-y-auto">
              <div className="p-6">
                <div className="flex justify-between items-center mb-6">
                  <h2 className="text-xl font-bold">Process Payment</h2>
                  <button
                    onClick={() => {
                      setShowPaymentModal(false);
                      setSelectedPayment(null);
                    }}
                    className="text-gray-400 hover:text-gray-600"
                  >
                    <svg className="w-6 h-6" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                      <path
                        strokeLinecap="round"
                        strokeLinejoin="round"
                        strokeWidth={2}
                        d="M6 18L18 6M6 6l12 12"
                      />
                    </svg>
                  </button>
                </div>

                <div className="mb-6">
                  <div className="bg-gray-50 p-4 rounded-lg">
                    <h3 className="text-lg font-semibold mb-2">{selectedPayment.vendorName}</h3>
                    <div className="grid grid-cols-2 gap-4">
                      <div>
                        <label className="text-sm font-medium text-gray-600">Invoice</label>
                        <p className="text-gray-900">{selectedPayment.invoiceNumber}</p>
                      </div>
                      <div>
                        <label className="text-sm font-medium text-gray-600">Order ID</label>
                        <p className="text-gray-900">{selectedPayment.orderId}</p>
                      </div>
                      <div>
                        <label className="text-sm font-medium text-gray-600">Total Amount</label>
                        <p className="text-gray-900">{formatINR(selectedPayment.amount)}</p>
                      </div>
                      <div>
                        <label className="text-sm font-medium text-gray-600">Balance Due</label>
                        <p className="text-gray-900 font-semibold">
                          {formatINR(selectedPayment.balance)}
                        </p>
                      </div>
                    </div>
                  </div>
                </div>

                {selectedPayment.payments.length > 0 && (
                  <div className="mb-6">
                    <h3 className="text-lg font-semibold mb-4">Payment History</h3>
                    <div className="space-y-3">
                      {selectedPayment.payments.map((payment, index) => (
                        <div
                          key={index}
                          className="flex justify-between items-center p-3 bg-green-50 rounded-lg"
                        >
                          <div>
                            <p className="font-medium">{formatINR(payment.amount)}</p>
                            <p className="text-sm text-gray-600">
                              {payment.date} • {payment.method}
                            </p>
                          </div>
                          <span className="text-sm text-gray-600">{payment.reference}</span>
                        </div>
                      ))}
                    </div>
                  </div>
                )}

                <form onSubmit={processPayment}>
                  <div className="grid grid-cols-1 md:grid-cols-2 gap-4 mb-4">
                    <div>
                      <label className="block text-sm font-medium text-gray-700 mb-1">
                        Payment Amount *
                      </label>
                      <input
                        type="number"
                        required
                        className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-black focus:border-transparent"
                        value={paymentForm.amount}
                        onChange={(e) => setPaymentForm({ ...paymentForm, amount: e.target.value })}
                        max={selectedPayment.balance}
                        min="0"
                        step="0.01"
                      />
                      <p className="text-xs text-gray-500 mt-1">
                        Maximum: {formatINR(selectedPayment.balance)}
                      </p>
                    </div>
                    <div>
                      <label className="block text-sm font-medium text-gray-700 mb-1">
                        Payment Date *
                      </label>
                      <input
                        type="date"
                        required
                        className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-black focus:border-transparent"
                        value={paymentForm.paymentDate}
                        onChange={(e) =>
                          setPaymentForm({ ...paymentForm, paymentDate: e.target.value })
                        }
                      />
                    </div>
                    <div>
                      <label className="block text-sm font-medium text-gray-700 mb-1">
                        Payment Method *
                      </label>
                      <select
                        required
                        className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-black focus:border-transparent"
                        value={paymentForm.paymentMethod}
                        onChange={(e) =>
                          setPaymentForm({ ...paymentForm, paymentMethod: e.target.value })
                        }
                      >
                        <option value="">Select Method</option>
                        <option value="Bank Transfer">Bank Transfer</option>
                        <option value="UPI">UPI</option>
                        <option value="Cheque">Cheque</option>
                        <option value="Cash">Cash</option>
                        <option value="Credit Card">Credit Card</option>
                      </select>
                    </div>
                    <div>
                      <label className="block text-sm font-medium text-gray-700 mb-1">
                        Reference Number
                      </label>
                      <input
                        type="text"
                        className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-black focus:border-transparent"
                        value={paymentForm.referenceNumber}
                        onChange={(e) =>
                          setPaymentForm({ ...paymentForm, referenceNumber: e.target.value })
                        }
                        placeholder="Transaction ID/Cheque No."
                      />
                    </div>
                    <div className="md:col-span-2">
                      <label className="block text-sm font-medium text-gray-700 mb-1">Notes</label>
                      <textarea
                        className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-black focus:border-transparent"
                        rows="3"
                        value={paymentForm.notes}
                        onChange={(e) => setPaymentForm({ ...paymentForm, notes: e.target.value })}
                        placeholder="Additional payment notes..."
                      />
                    </div>
                  </div>

                  <div className="flex justify-between items-center mb-4">
                    <div className="text-lg font-semibold">
                      Payment: {formatINR(parseFloat(paymentForm.amount) || 0)}
                      {parseFloat(paymentForm.amount) < selectedPayment.balance && (
                        <span className="text-sm text-blue-600 ml-2">(Partial Payment)</span>
                      )}
                    </div>
                  </div>

                  <div className="flex justify-end space-x-3 pt-4 border-t">
                    <button
                      type="button"
                      onClick={() => {
                        setShowPaymentModal(false);
                        setSelectedPayment(null);
                      }}
                      className="bg-white text-gray-700 px-4 py-2 rounded-lg border border-gray-300 hover:bg-gray-50"
                    >
                      Cancel
                    </button>
                    <button
                      type="submit"
                      className="bg-black text-white px-4 py-2 rounded-lg hover:bg-gray-800"
                    >
                      Process Payment
                    </button>
                  </div>
                </form>
              </div>
            </div>
          </div>
        )}

        {/* Create PO Modal */}
        {showCreatePOModal && (
          <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center p-4 z-50">
            <div className="bg-white rounded-lg max-w-4xl w-full max-h-[90vh] overflow-y-auto">
              <div className="p-6">
                <div className="flex justify-between items-center mb-4">
                  <h2 className="text-xl font-bold">Create Purchase Order</h2>
                  <button
                    onClick={() => {
                      setShowCreatePOModal(false);
                      resetPoForm();
                    }}
                    className="text-gray-400 hover:text-gray-600"
                  >
                    <svg className="w-6 h-6" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                      <path
                        strokeLinecap="round"
                        strokeLinejoin="round"
                        strokeWidth={2}
                        d="M6 18L18 6M6 6l12 12"
                      />
                    </svg>
                  </button>
                </div>

                <form onSubmit={createPurchaseOrder}>
                  <div className="grid grid-cols-1 md:grid-cols-2 gap-4 mb-4">
                    <div>
                      <label className="block text-sm font-medium text-gray-700 mb-1">
                        Vendor *
                      </label>
                      <select
                        required
                        className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-black focus:border-transparent"
                        value={poForm.vendor}
                        onChange={(e) => setPoForm({ ...poForm, vendor: e.target.value })}
                      >
                        <option value="">Select Vendor</option>
                        {vendors.map((vendor) => (
                          <option key={vendor.id} value={vendor.name}>
                            {vendor.name}
                          </option>
                        ))}
                      </select>
                    </div>
                    <div>
                      <label className="block text-sm font-medium text-gray-700 mb-1">
                        Department *
                      </label>
                      <select
                        required
                        className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-black focus:border-transparent"
                        value={poForm.department}
                        onChange={(e) => setPoForm({ ...poForm, department: e.target.value })}
                      >
                        <option value="">Select Department</option>
                        <option value="Housekeeping">Housekeeping</option>
                        <option value="Kitchen">Kitchen</option>
                        <option value="Front Desk">Front Desk</option>
                        <option value="Maintenance">Maintenance</option>
                      </select>
                    </div>
                    <div>
                      <label className="block text-sm font-medium text-gray-700 mb-1">
                        Required Date *
                      </label>
                      <input
                        type="date"
                        required
                        className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-black focus:border-transparent"
                        value={poForm.dateRequired}
                        onChange={(e) => setPoForm({ ...poForm, dateRequired: e.target.value })}
                      />
                    </div>
                    <div>
                      <label className="block text-sm font-medium text-gray-700 mb-1">
                        Priority
                      </label>
                      <select
                        className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-black focus:border-transparent"
                        value={poForm.priority}
                        onChange={(e) => setPoForm({ ...poForm, priority: e.target.value })}
                      >
                        <option value="low">Low</option>
                        <option value="medium">Medium</option>
                        <option value="high">High</option>
                      </select>
                    </div>
                  </div>

                  <div className="mb-4">
                    <div className="flex justify-between items-center mb-2">
                      <label className="block text-sm font-medium text-gray-700">Items *</label>
                      <button
                        type="button"
                        onClick={() => addItem(false)}
                        className="text-blue-600 hover:text-blue-800 text-sm"
                      >
                        + Add Item
                      </button>
                    </div>
                    {poForm.items.map((item, index) => (
                      <div key={index} className="flex gap-2 mb-2">
                        <input
                          type="text"
                          placeholder="Item name"
                          className="flex-1 px-3 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-black focus:border-transparent"
                          value={item.name}
                          onChange={(e) => updateItem(index, 'name', e.target.value, false)}
                          required
                        />
                        <input
                          type="number"
                          placeholder="Qty"
                          className="w-20 px-3 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-black focus:border-transparent"
                          value={item.quantity}
                          onChange={(e) =>
                            updateItem(index, 'quantity', parseInt(e.target.value), false)
                          }
                          min="1"
                          required
                        />
                        <input
                          type="number"
                          step="0.01"
                          placeholder="Price"
                          className="w-32 px-3 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-black focus:border-transparent"
                          value={item.unitPrice}
                          onChange={(e) =>
                            updateItem(index, 'unitPrice', parseFloat(e.target.value), false)
                          }
                          min="0"
                          required
                        />
                        {poForm.items.length > 1 && (
                          <button
                            type="button"
                            onClick={() => removeItem(index, false)}
                            className="text-red-600 hover:text-red-800 px-2"
                          >
                            ×
                          </button>
                        )}
                      </div>
                    ))}
                  </div>

                  <div className="flex justify-between items-center mb-4">
                    <div className="text-lg font-semibold">
                      Total: ₹{calculateTotal(requestForm.items).toFixed(2)}
                    </div>
                  </div>

                  <div className="flex justify-end space-x-3 pt-4 border-t">
                    <button
                      type="button"
                      onClick={() => {
                        setShowCreatePOModal(false);
                        resetPoForm();
                      }}
                      className="bg-white text-gray-700 px-4 py-2 rounded-lg border border-gray-300 hover:bg-gray-50"
                    >
                      Cancel
                    </button>
                    <button
                      type="submit"
                      className="bg-black text-white px-4 py-2 rounded-lg hover:bg-gray-800"
                    >
                      Create & Send to Vendor
                    </button>
                  </div>
                </form>
              </div>
            </div>
          </div>
        )}

        {/* Request PO Modal */}
        {showRequestPOModal && (
          <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center p-4 z-50">
            <div className="bg-white rounded-lg max-w-4xl w-full max-h-[90vh] overflow-y-auto">
              <div className="p-6">
                <div className="flex justify-between items-center mb-4">
                  <h2 className="text-xl font-bold">Request Purchase Order</h2>
                  <button
                    onClick={() => {
                      setShowRequestPOModal(false);
                      resetRequestForm();
                    }}
                    className="text-gray-400 hover:text-gray-600"
                  >
                    <svg className="w-6 h-6" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                      <path
                        strokeLinecap="round"
                        strokeLinejoin="round"
                        strokeWidth={2}
                        d="M6 18L18 6M6 6l12 12"
                      />
                    </svg>
                  </button>
                </div>

                <form onSubmit={submitPurchaseRequest}>
                  <div className="grid grid-cols-1 md:grid-cols-2 gap-4 mb-4">
                    <div>
                      <label className="block text-sm font-medium text-gray-700 mb-1">
                        Vendor *
                      </label>
                      <select
                        required
                        className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-black focus:border-transparent"
                        value={requestForm.vendor}
                        onChange={(e) => setRequestForm({ ...requestForm, vendor: e.target.value })}
                      >
                        <option value="">Select Vendor</option>
                        {vendors.map((vendor) => (
                          <option key={vendor.id} value={vendor.name}>
                            {vendor.name}
                          </option>
                        ))}
                      </select>
                    </div>
                    <div>
                      <label className="block text-sm font-medium text-gray-700 mb-1">
                        Department *
                      </label>
                      <select
                        required
                        className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-black focus:border-transparent"
                        value={requestForm.department}
                        onChange={(e) =>
                          setRequestForm({ ...requestForm, department: e.target.value })
                        }
                      >
                        <option value="">Select Department</option>
                        <option value="Housekeeping">Housekeeping</option>
                        <option value="Kitchen">Kitchen</option>
                        <option value="Front Desk">Front Desk</option>
                        <option value="Maintenance">Maintenance</option>
                      </select>
                    </div>
                    <div>
                      <label className="block text-sm font-medium text-gray-700 mb-1">
                        Required Date *
                      </label>
                      <input
                        type="date"
                        required
                        className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-black focus:border-transparent"
                        value={requestForm.dateRequired}
                        onChange={(e) =>
                          setRequestForm({ ...requestForm, dateRequired: e.target.value })
                        }
                      />
                    </div>
                    <div>
                      <label className="block text-sm font-medium text-gray-700 mb-1">
                        Priority
                      </label>
                      <select
                        className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-black focus:border-transparent"
                        value={requestForm.priority}
                        onChange={(e) =>
                          setRequestForm({ ...requestForm, priority: e.target.value })
                        }
                      >
                        <option value="low">Low</option>
                        <option value="medium">Medium</option>
                        <option value="high">High</option>
                      </select>
                    </div>
                  </div>

                  <div className="mb-4">
                    <label className="block text-sm font-medium text-gray-700 mb-1">
                      Reason for Request *
                    </label>
                    <textarea
                      className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-black focus:border-transparent"
                      rows="3"
                      value={requestForm.reason}
                      onChange={(e) => setRequestForm({ ...requestForm, reason: e.target.value })}
                      placeholder="Explain why these items are needed..."
                      required
                    />
                  </div>

                  <div className="mb-4">
                    <div className="flex justify-between items-center mb-2">
                      <label className="block text-sm font-medium text-gray-700">
                        Items Needed *
                      </label>
                      <button
                        type="button"
                        onClick={() => addItem(true)}
                        className="text-blue-600 hover:text-blue-800 text-sm"
                      >
                        + Add Item
                      </button>
                    </div>
                    {requestForm.items.map((item, index) => (
                      <div key={index} className="flex gap-2 mb-2">
                        <input
                          type="text"
                          placeholder="Item name"
                          className="flex-1 px-3 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-black focus:border-transparent"
                          value={item.name}
                          onChange={(e) => updateItem(index, 'name', e.target.value, true)}
                          required
                        />
                        <input
                          type="number"
                          placeholder="Qty"
                          className="w-20 px-3 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-black focus:border-transparent"
                          value={item.quantity}
                          onChange={(e) =>
                            updateItem(index, 'quantity', parseInt(e.target.value), true)
                          }
                          min="1"
                          required
                        />
                        <input
                          type="number"
                          step="0.01"
                          placeholder="Price"
                          className="w-32 px-3 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-black focus:border-transparent"
                          value={item.unitPrice}
                          onChange={(e) =>
                            updateItem(index, 'unitPrice', parseFloat(e.target.value), true)
                          }
                          min="0"
                          required
                        />
                        {requestForm.items.length > 1 && (
                          <button
                            type="button"
                            onClick={() => removeItem(index, true)}
                            className="text-red-600 hover:text-red-800 px-2"
                          >
                            ×
                          </button>
                        )}
                      </div>
                    ))}
                  </div>

                  <div className="flex justify-between items-center mb-4">
                    <div className="text-lg font-semibold">
                      Total: ₹{calculateTotal(requestForm.items).toFixed(2)}
                    </div>
                  </div>

                  <div className="flex justify-end space-x-3 pt-4 border-t">
                    <button
                      type="button"
                      onClick={() => {
                        setShowRequestPOModal(false);
                        resetRequestForm();
                      }}
                      className="bg-white text-gray-700 px-4 py-2 rounded-lg border border-gray-300 hover:bg-gray-50"
                    >
                      Cancel
                    </button>
                    <button
                      type="submit"
                      className="bg-black text-white px-4 py-2 rounded-lg hover:bg-gray-800"
                    >
                      Submit for Approval
                    </button>
                  </div>
                </form>
              </div>
            </div>
          </div>
        )}
      </div>
    </div>
  );
};

export default SupplyChainAndProcurement;
